var map = {
	"./font/DMSans-Italic.woff2": 13847,
	"./font/DMSans.woff2": 71822,
	"./font/Fraunces-Italic.woff2": 90288,
	"./font/Fraunces.woff2": 9820,
	"./font/SharpGrotesk/SharpGrotesk-Black20.woff2": 39541,
	"./font/SharpGrotesk/SharpGrotesk-BlackItalic20.woff2": 33672,
	"./font/SharpGrotesk/SharpGrotesk-Bold20.woff2": 51298,
	"./font/SharpGrotesk/SharpGrotesk-BoldItalic20.woff2": 15664,
	"./font/SharpGrotesk/SharpGrotesk-Book20.woff2": 77576,
	"./font/SharpGrotesk/SharpGrotesk-BookItalic20.woff2": 39740,
	"./font/SharpGrotesk/SharpGrotesk-LightItalic20.woff2": 6387,
	"./font/SharpGrotesk/SharpGrotesk-Medium20.woff2": 18119,
	"./font/SharpGrotesk/SharpGrotesk-MediumItalic20.woff2": 12158,
	"./font/SharpGrotesk/SharpGrotesk-SemiBold20.woff2": 39717,
	"./font/SharpGrotesk/SharpGrotesk-SemiBoldItalic20.woff2": 85838,
	"./font/SharpGrotesk/SharpGrotesk-ThinItalic20.woff2": 80825,
	"./image/branding/anyways.png": 6705,
	"./image/branding/buck-icon.png": 22006,
	"./image/branding/buck.png": 38286,
	"./image/branding/creativelivesinprogress.png": 69265,
	"./image/branding/giantant.png": 62838,
	"./image/branding/ifyoucould.png": 24222,
	"./image/branding/itsnicethat.png": 4697,
	"./image/branding/partandsum.png": 55496,
	"./image/branding/residence.png": 79874,
	"./image/branding/vtpro.png": 47905,
	"./image/branding/wild.png": 91506,
	"./image/graphic/2023-bcorp-background.webp": 16283,
	"./image/graphic/2023-bcorp-crystal-00.webp": 93126,
	"./image/graphic/2023-bcorp-crystal-01.webp": 68174,
	"./image/graphic/2023-bcorp-crystal-02.webp": 56704,
	"./image/graphic/2023-bcorp-crystal-03.webp": 6685,
	"./image/graphic/2023-bcorp-crystal-04.webp": 28779,
	"./image/graphic/2023-bcorp-crystal-05.webp": 52086,
	"./image/graphic/2023-bcorp-crystal-06.webp": 97858,
	"./image/graphic/2023-bcorp.webp": 4670,
	"./image/graphic/2023-cloud-00.webp": 90684,
	"./image/graphic/2023-cloud-01.webp": 99098,
	"./image/graphic/2023-cloud-02.webp": 38066,
	"./image/graphic/2023-cloud.webp": 25633,
	"./image/graphic/2023-egg.png": 61288,
	"./image/graphic/2023-egg.webp": 33191,
	"./image/graphic/2023-flowers.webp": 92493,
	"./image/graphic/2023-hero-background.webp": 34004,
	"./image/graphic/2023-noplanetb.webp": 78859,
	"./image/graphic/2023-planetpeopleprogress.webp": 74429,
	"./image/graphic/2023-raindrop.webp": 34872,
	"./image/graphic/future-401kmatch.webp": 16249,
	"./image/graphic/future-brightest.webp": 84890,
	"./image/graphic/future-clouds-front.webp": 61120,
	"./image/graphic/future-clouds.webp": 68099,
	"./image/graphic/future-hero-background.webp": 68860,
	"./image/graphic/future-mentorship.webp": 56397,
	"./image/graphic/future-orb-00.webp": 28410,
	"./image/graphic/future-orb-01.webp": 9027,
	"./image/graphic/future-orb-02.webp": 34201,
	"./image/graphic/future-orb-03.webp": 91298,
	"./image/graphic/future-overtimebonuses.webp": 3193,
	"./image/graphic/future-pastyear.webp": 85915,
	"./image/graphic/future-playground.webp": 80409,
	"./image/graphic/future-summerfridays.webp": 88419,
	"./image/graphic/overview-accent-cloud-00.webp": 88102,
	"./image/graphic/overview-accent-cloud-01.webp": 8293,
	"./image/graphic/overview-accent-cloudsun.webp": 92498,
	"./image/graphic/overview-accent-glare-00.webp": 5642,
	"./image/graphic/overview-accent-glare-01.webp": 20370,
	"./image/graphic/overview-accent-glare-02.webp": 81342,
	"./image/graphic/overview-accent-glare-03.webp": 60722,
	"./image/graphic/overview-accent-sphere-00.webp": 29758,
	"./image/graphic/overview-accent-sphere-01.webp": 40230,
	"./image/graphic/overview-accent-sphere-02.webp": 70157,
	"./image/graphic/overview-company-anyways.webp": 11216,
	"./image/graphic/overview-company-buck.webp": 9155,
	"./image/graphic/overview-company-creativelivesinprogress.webp": 53816,
	"./image/graphic/overview-company-giantant.webp": 32848,
	"./image/graphic/overview-company-ifyoucould.webp": 68835,
	"./image/graphic/overview-company-itsnicethat.webp": 20855,
	"./image/graphic/overview-company-partandsum.webp": 22631,
	"./image/graphic/overview-company-residence.webp": 72637,
	"./image/graphic/overview-company-vtpro.webp": 33073,
	"./image/graphic/overview-company-wild.webp": 67043,
	"./image/graphic/overview-hero-background.webp": 17619,
	"./image/graphic/overview-pipes-2.png": 33795,
	"./image/graphic/overview-pipes-2.webp": 4396,
	"./image/graphic/overview-pipes-3.webp": 77141,
	"./image/graphic/overview-pipes.png": 42046,
	"./image/graphic/overview-pipes.webp": 82252,
	"./image/graphic/overview-river-2-.webp": 31484,
	"./image/graphic/overview-river.png": 80930,
	"./image/graphic/overview-river.webp": 19330,
	"./image/graphic/overview-sphere-00.webp": 69179,
	"./image/graphic/overview-sphere-01.webp": 76580,
	"./image/graphic/overview-sphere-02.webp": 37331,
	"./image/graphic/overview-timeline-2004-00.webp": 30013,
	"./image/graphic/overview-timeline-2004-01.webp": 4192,
	"./image/graphic/overview-timeline-2006-00.webp": 67305,
	"./image/graphic/overview-timeline-2006-01.webp": 27435,
	"./image/graphic/overview-timeline-2008-00.webp": 35290,
	"./image/graphic/overview-timeline-2008-01.webp": 37064,
	"./image/graphic/overview-timeline-2010-00.mp4": 97325,
	"./image/graphic/overview-timeline-2010-00.webm": 29071,
	"./image/graphic/overview-timeline-2012-00.webp": 39484,
	"./image/graphic/overview-timeline-2014-00.mp4": 79522,
	"./image/graphic/overview-timeline-2014-00.webm": 13589,
	"./image/graphic/overview-timeline-2015-00.webp": 82305,
	"./image/graphic/overview-timeline-2015-01.webp": 74418,
	"./image/graphic/overview-timeline-2017-00-long.mp4": 45833,
	"./image/graphic/overview-timeline-2017-00-short.mp4": 90088,
	"./image/graphic/overview-timeline-2018-00.webp": 69516,
	"./image/graphic/overview-timeline-2018-01.gif": 29764,
	"./image/graphic/overview-timeline-2018-01.mp4": 78636,
	"./image/graphic/overview-timeline-2018-02.gif": 30089,
	"./image/graphic/overview-timeline-2021-00.webp": 4573,
	"./image/graphic/people-adoberetreat.webp": 49826,
	"./image/graphic/people-babies.webp": 24810,
	"./image/graphic/people-buckcareers.webp": 57935,
	"./image/graphic/people-buckgoods.webp": 29592,
	"./image/graphic/people-bucksandbox.webp": 84257,
	"./image/graphic/people-buckuback.webp": 4316,
	"./image/graphic/people-card-data-department.webp": 97195,
	"./image/graphic/people-card-data-leadership.webp": 52089,
	"./image/graphic/people-card-data-newhires.webp": 89305,
	"./image/graphic/people-card-data-office.webp": 89837,
	"./image/graphic/people-card-data-slack.webp": 25110,
	"./image/graphic/people-card-data-staff.webp": 81503,
	"./image/graphic/people-card-data-tenure.webp": 7377,
	"./image/graphic/people-card-department.webp": 56442,
	"./image/graphic/people-card-diversity-age.webp": 69072,
	"./image/graphic/people-card-diversity-disability.webp": 25727,
	"./image/graphic/people-card-diversity-diversity.webp": 70854,
	"./image/graphic/people-card-diversity-erg.webp": 97098,
	"./image/graphic/people-card-diversity-esl.webp": 59928,
	"./image/graphic/people-card-diversity-familystatus.webp": 2080,
	"./image/graphic/people-card-diversity-gender.webp": 12736,
	"./image/graphic/people-card-diversity-sexualorientation.webp": 31001,
	"./image/graphic/people-card-erg-a.webp": 53695,
	"./image/graphic/people-card-erg-b.webp": 55118,
	"./image/graphic/people-card-erg-c.webp": 9634,
	"./image/graphic/people-coloringbook.webp": 94081,
	"./image/graphic/people-community.webp": 56828,
	"./image/graphic/people-hero-background.webp": 10889,
	"./image/graphic/people-hiring.webp": 53661,
	"./image/graphic/people-honoringnonconformity.webp": 32722,
	"./image/graphic/people-orb-00.webp": 85928,
	"./image/graphic/people-orb-01.webp": 8914,
	"./image/graphic/people-orb-02.webp": 87110,
	"./image/graphic/people-orb-03.webp": 14450,
	"./image/graphic/people-strategyspeakeasy.webp": 99605,
	"./image/graphic/people-talent.webp": 31245,
	"./image/graphic/people-valley.jpg": 63738,
	"./image/graphic/people-valley.webp": 20943,
	"./image/graphic/planet-brightest.webp": 39833,
	"./image/graphic/planet-card-crafting-a.webp": 39339,
	"./image/graphic/planet-card-crafting-b.webp": 17821,
	"./image/graphic/planet-card-crafting-c.webp": 26925,
	"./image/graphic/planet-card-crafting-d.webp": 95593,
	"./image/graphic/planet-card-crafting-e.webp": 75373,
	"./image/graphic/planet-card-crafting-f.webp": 79477,
	"./image/graphic/planet-climateaction.webp": 63017,
	"./image/graphic/planet-emissions-byemployee.webp": 41916,
	"./image/graphic/planet-emissions-bylocation.webp": 71570,
	"./image/graphic/planet-emissions-total.webp": 76879,
	"./image/graphic/planet-emissions-wheel.webp": 12789,
	"./image/graphic/planet-emissions.webp": 56904,
	"./image/graphic/planet-hero-background.webp": 47710,
	"./image/graphic/planet-leedcertified.webp": 88410,
	"./image/graphic/planet-orb-00.webp": 51755,
	"./image/graphic/planet-orb-01.webp": 99758,
	"./image/graphic/planet-orb-02.webp": 30434,
	"./image/graphic/planet-orb-03.webp": 31011,
	"./image/graphic/planet-ourprinciples.webp": 50338,
	"./image/graphic/planet-principles-background.webp": 6668,
	"./image/graphic/planet-principles.webp": 86864,
	"./image/graphic/planet-project-2x4.webp": 25176,
	"./image/graphic/planet-project-ketikoti.webp": 13956,
	"./image/graphic/planet-project-kurzgesagt.webp": 32508,
	"./image/graphic/planet-project-thelastwhiterhino.webp": 24539,
	"./image/graphic/planet-sustainable-background.webp": 91725,
	"./image/graphic/planet-usgbc-group.webp": 87301,
	"./image/graphic/planet-usgbc-header.webp": 9970,
	"./image/graphic/planet-usgbc.webp": 54169,
	"./image/graphic/progress-card-employeedev.webp": 67718,
	"./image/graphic/progress-card-upwardmobility.webp": 57949,
	"./image/graphic/progress-charting-background-2.webp": 20701,
	"./image/graphic/progress-charting-background.jpg": 97634,
	"./image/graphic/progress-charting-background.webp": 19821,
	"./image/graphic/progress-chartingnewpaths.webp": 62193,
	"./image/graphic/progress-crossingdisciplines-background.webp": 19718,
	"./image/graphic/progress-crossingdisciplines.webp": 23803,
	"./image/graphic/progress-cube.webp": 74925,
	"./image/graphic/progress-gaming.webp": 31758,
	"./image/graphic/progress-hero-background.webp": 83327,
	"./image/graphic/progress-letsrevolution copy.webp": 53283,
	"./image/graphic/progress-letsrevolution.webp": 82520,
	"./image/graphic/progress-orb-00.webp": 76605,
	"./image/graphic/progress-orb-01.webp": 11127,
	"./image/graphic/progress-orb-02.webp": 92462,
	"./image/graphic/progress-orb-03.webp": 90401,
	"./image/graphic/progress-projects.webp": 13901,
	"./image/graphic/progress-rnd.webp": 54859,
	"./image/graphic/progress-upwardmobility.webp": 88475,
	"./image/icon/arrow-right.svg": 41480,
	"./image/poster/2023-breakingcircle-poster.webp": 89534,
	"./image/poster/2023-earthfloater-poster.webp": 14470,
	"./image/poster/2023-ring-poster.webp": 87570,
	"./image/poster/future-clouds-poster.webp": 61096,
	"./image/poster/future.webp": 13986,
	"./image/poster/overview-shapeofchange-poster.webp": 66249,
	"./image/poster/people-balance-poster.webp": 94143,
	"./image/poster/people.webp": 68051,
	"./image/poster/planet-planter-poster.webp": 12615,
	"./image/poster/planet.webp": 31392,
	"./image/poster/progress-3squares-poster.webp": 14426,
	"./image/poster/progress.webp": 90377,
	"./image/sequence/balance-initial/balance-initial-0001.webp": 75311,
	"./image/sequence/balance-initial/balance-initial-0002.webp": 24466,
	"./image/sequence/balance-initial/balance-initial-0003.webp": 71734,
	"./image/sequence/balance-initial/balance-initial-0004.webp": 46432,
	"./image/sequence/balance-initial/balance-initial-0005.webp": 32480,
	"./image/sequence/balance-initial/balance-initial-0006.webp": 1843,
	"./image/sequence/balance-initial/balance-initial-0007.webp": 55816,
	"./image/sequence/balance-initial/balance-initial-0008.webp": 57024,
	"./image/sequence/balance-initial/balance-initial-0009.webp": 12955,
	"./image/sequence/balance-initial/balance-initial-0010.webp": 69522,
	"./image/sequence/balance-initial/balance-initial-0011.webp": 62025,
	"./image/sequence/balance-initial/balance-initial-0012.webp": 86282,
	"./image/sequence/balance-initial/balance-initial-0013.webp": 18550,
	"./image/sequence/balance-initial/balance-initial-0014.webp": 68841,
	"./image/sequence/balance-initial/balance-initial-0015.webp": 61998,
	"./image/sequence/balance-initial/balance-initial-0016.webp": 13795,
	"./image/sequence/balance-initial/balance-initial-0017.webp": 39453,
	"./image/sequence/balance-initial/balance-initial-0018.webp": 55972,
	"./image/sequence/balance-initial/balance-initial-0019.webp": 29348,
	"./image/sequence/balance-initial/balance-initial-0020.webp": 81374,
	"./video/2023-breakingcircle-idle.webm": 6090,
	"./video/2023-breakingcircle-idle/00.webp": 93500,
	"./video/2023-breakingcircle-idle/01.webp": 21221,
	"./video/2023-breakingcircle-idle/02.webp": 1896,
	"./video/2023-breakingcircle-idle/03.webp": 55540,
	"./video/2023-breakingcircle-idle/04.webp": 60702,
	"./video/2023-breakingcircle-idle/05.webp": 98972,
	"./video/2023-breakingcircle-idle/06.webp": 99905,
	"./video/2023-breakingcircle-idle/07.webp": 58061,
	"./video/2023-breakingcircle-idle/08.webp": 42792,
	"./video/2023-breakingcircle-idle/09.webp": 64555,
	"./video/2023-breakingcircle-idle/10.webp": 8493,
	"./video/2023-breakingcircle-idle/100.webp": 54154,
	"./video/2023-breakingcircle-idle/101.webp": 98019,
	"./video/2023-breakingcircle-idle/102.webp": 76498,
	"./video/2023-breakingcircle-idle/103.webp": 99735,
	"./video/2023-breakingcircle-idle/104.webp": 34243,
	"./video/2023-breakingcircle-idle/105.webp": 17909,
	"./video/2023-breakingcircle-idle/106.webp": 89757,
	"./video/2023-breakingcircle-idle/107.webp": 99155,
	"./video/2023-breakingcircle-idle/108.webp": 92994,
	"./video/2023-breakingcircle-idle/109.webp": 82655,
	"./video/2023-breakingcircle-idle/11.webp": 54199,
	"./video/2023-breakingcircle-idle/110.webp": 27564,
	"./video/2023-breakingcircle-idle/111.webp": 18436,
	"./video/2023-breakingcircle-idle/112.webp": 38519,
	"./video/2023-breakingcircle-idle/113.webp": 7866,
	"./video/2023-breakingcircle-idle/114.webp": 53325,
	"./video/2023-breakingcircle-idle/115.webp": 6137,
	"./video/2023-breakingcircle-idle/116.webp": 89586,
	"./video/2023-breakingcircle-idle/117.webp": 37995,
	"./video/2023-breakingcircle-idle/118.webp": 22256,
	"./video/2023-breakingcircle-idle/119.webp": 64848,
	"./video/2023-breakingcircle-idle/12.webp": 91029,
	"./video/2023-breakingcircle-idle/120.webp": 55744,
	"./video/2023-breakingcircle-idle/121.webp": 49641,
	"./video/2023-breakingcircle-idle/122.webp": 75706,
	"./video/2023-breakingcircle-idle/123.webp": 73069,
	"./video/2023-breakingcircle-idle/124.webp": 78246,
	"./video/2023-breakingcircle-idle/125.webp": 58238,
	"./video/2023-breakingcircle-idle/126.webp": 84061,
	"./video/2023-breakingcircle-idle/127.webp": 17523,
	"./video/2023-breakingcircle-idle/128.webp": 18507,
	"./video/2023-breakingcircle-idle/129.webp": 62277,
	"./video/2023-breakingcircle-idle/13.webp": 76730,
	"./video/2023-breakingcircle-idle/130.webp": 73404,
	"./video/2023-breakingcircle-idle/131.webp": 41081,
	"./video/2023-breakingcircle-idle/132.webp": 29438,
	"./video/2023-breakingcircle-idle/133.webp": 38128,
	"./video/2023-breakingcircle-idle/134.webp": 48231,
	"./video/2023-breakingcircle-idle/135.webp": 40900,
	"./video/2023-breakingcircle-idle/136.webp": 82438,
	"./video/2023-breakingcircle-idle/137.webp": 84656,
	"./video/2023-breakingcircle-idle/14.webp": 6866,
	"./video/2023-breakingcircle-idle/15.webp": 39863,
	"./video/2023-breakingcircle-idle/16.webp": 43443,
	"./video/2023-breakingcircle-idle/17.webp": 89756,
	"./video/2023-breakingcircle-idle/18.webp": 78479,
	"./video/2023-breakingcircle-idle/19.webp": 90126,
	"./video/2023-breakingcircle-idle/20.webp": 89449,
	"./video/2023-breakingcircle-idle/21.webp": 28859,
	"./video/2023-breakingcircle-idle/22.webp": 12438,
	"./video/2023-breakingcircle-idle/23.webp": 23974,
	"./video/2023-breakingcircle-idle/24.webp": 26496,
	"./video/2023-breakingcircle-idle/25.webp": 24767,
	"./video/2023-breakingcircle-idle/26.webp": 86188,
	"./video/2023-breakingcircle-idle/27.webp": 54301,
	"./video/2023-breakingcircle-idle/28.webp": 74241,
	"./video/2023-breakingcircle-idle/29.webp": 93995,
	"./video/2023-breakingcircle-idle/30.webp": 79778,
	"./video/2023-breakingcircle-idle/31.webp": 51406,
	"./video/2023-breakingcircle-idle/32.webp": 37086,
	"./video/2023-breakingcircle-idle/33.webp": 76856,
	"./video/2023-breakingcircle-idle/34.webp": 10990,
	"./video/2023-breakingcircle-idle/35.webp": 35027,
	"./video/2023-breakingcircle-idle/36.webp": 31977,
	"./video/2023-breakingcircle-idle/37.webp": 75984,
	"./video/2023-breakingcircle-idle/38.webp": 22309,
	"./video/2023-breakingcircle-idle/39.webp": 19489,
	"./video/2023-breakingcircle-idle/40.webp": 77799,
	"./video/2023-breakingcircle-idle/41.webp": 49875,
	"./video/2023-breakingcircle-idle/42.webp": 78740,
	"./video/2023-breakingcircle-idle/43.webp": 80299,
	"./video/2023-breakingcircle-idle/44.webp": 21559,
	"./video/2023-breakingcircle-idle/45.webp": 37890,
	"./video/2023-breakingcircle-idle/46.webp": 66827,
	"./video/2023-breakingcircle-idle/47.webp": 1422,
	"./video/2023-breakingcircle-idle/48.webp": 22106,
	"./video/2023-breakingcircle-idle/49.webp": 30724,
	"./video/2023-breakingcircle-idle/50.webp": 46890,
	"./video/2023-breakingcircle-idle/51.webp": 86087,
	"./video/2023-breakingcircle-idle/52.webp": 21034,
	"./video/2023-breakingcircle-idle/53.webp": 33094,
	"./video/2023-breakingcircle-idle/54.webp": 47860,
	"./video/2023-breakingcircle-idle/55.webp": 44576,
	"./video/2023-breakingcircle-idle/56.webp": 62411,
	"./video/2023-breakingcircle-idle/57.webp": 1225,
	"./video/2023-breakingcircle-idle/58.webp": 50337,
	"./video/2023-breakingcircle-idle/59.webp": 68412,
	"./video/2023-breakingcircle-idle/60.webp": 5340,
	"./video/2023-breakingcircle-idle/61.webp": 7132,
	"./video/2023-breakingcircle-idle/62.webp": 73467,
	"./video/2023-breakingcircle-idle/63.webp": 30692,
	"./video/2023-breakingcircle-idle/64.webp": 17554,
	"./video/2023-breakingcircle-idle/65.webp": 7357,
	"./video/2023-breakingcircle-idle/66.webp": 57105,
	"./video/2023-breakingcircle-idle/67.webp": 68760,
	"./video/2023-breakingcircle-idle/68.webp": 93835,
	"./video/2023-breakingcircle-idle/69.webp": 62092,
	"./video/2023-breakingcircle-idle/70.webp": 8782,
	"./video/2023-breakingcircle-idle/71.webp": 27317,
	"./video/2023-breakingcircle-idle/72.webp": 30938,
	"./video/2023-breakingcircle-idle/73.webp": 59073,
	"./video/2023-breakingcircle-idle/74.webp": 25114,
	"./video/2023-breakingcircle-idle/75.webp": 18915,
	"./video/2023-breakingcircle-idle/76.webp": 20969,
	"./video/2023-breakingcircle-idle/77.webp": 824,
	"./video/2023-breakingcircle-idle/78.webp": 98729,
	"./video/2023-breakingcircle-idle/79.webp": 6596,
	"./video/2023-breakingcircle-idle/80.webp": 26837,
	"./video/2023-breakingcircle-idle/81.webp": 54832,
	"./video/2023-breakingcircle-idle/82.webp": 11966,
	"./video/2023-breakingcircle-idle/83.webp": 95323,
	"./video/2023-breakingcircle-idle/84.webp": 32166,
	"./video/2023-breakingcircle-idle/85.webp": 24489,
	"./video/2023-breakingcircle-idle/86.webp": 97103,
	"./video/2023-breakingcircle-idle/87.webp": 67538,
	"./video/2023-breakingcircle-idle/88.webp": 63669,
	"./video/2023-breakingcircle-idle/89.webp": 48638,
	"./video/2023-breakingcircle-idle/90.webp": 27980,
	"./video/2023-breakingcircle-idle/91.webp": 14861,
	"./video/2023-breakingcircle-idle/92.webp": 75476,
	"./video/2023-breakingcircle-idle/93.webp": 89684,
	"./video/2023-breakingcircle-idle/94.webp": 83679,
	"./video/2023-breakingcircle-idle/95.webp": 13680,
	"./video/2023-breakingcircle-idle/96.webp": 77449,
	"./video/2023-breakingcircle-idle/97.webp": 67545,
	"./video/2023-breakingcircle-idle/98.webp": 88889,
	"./video/2023-breakingcircle-idle/99.webp": 14435,
	"./video/2023-breakingcircle-initial.webm": 57400,
	"./video/2023-breakingcircle-initial/00.webp": 63657,
	"./video/2023-breakingcircle-initial/01.webp": 77039,
	"./video/2023-breakingcircle-initial/02.webp": 66332,
	"./video/2023-breakingcircle-initial/03.webp": 90170,
	"./video/2023-breakingcircle-initial/04.webp": 52937,
	"./video/2023-breakingcircle-initial/05.webp": 93370,
	"./video/2023-breakingcircle-initial/06.webp": 62265,
	"./video/2023-breakingcircle-initial/07.webp": 78145,
	"./video/2023-breakingcircle-initial/08.webp": 44830,
	"./video/2023-breakingcircle-initial/09.webp": 59510,
	"./video/2023-breakingcircle-initial/10.webp": 37880,
	"./video/2023-breakingcircle-initial/11.webp": 88846,
	"./video/2023-breakingcircle-initial/12.webp": 83520,
	"./video/2023-breakingcircle-initial/13.webp": 21593,
	"./video/2023-breakingcircle-initial/14.webp": 90033,
	"./video/2023-breakingcircle-initial/15.webp": 60755,
	"./video/2023-breakingcircle-initial/16.webp": 22288,
	"./video/2023-breakingcircle-initial/17.webp": 79198,
	"./video/2023-breakingcircle-initial/18.webp": 95589,
	"./video/2023-breakingcircle-initial/19.webp": 10910,
	"./video/2023-breakingcircle-initial/20.webp": 26741,
	"./video/2023-breakingcircle-initial/21.webp": 14433,
	"./video/2023-breakingcircle-initial/22.webp": 14304,
	"./video/2023-breakingcircle-initial/23.webp": 98040,
	"./video/2023-breakingcircle-initial/24.webp": 49870,
	"./video/2023-breakingcircle-initial/25.webp": 86568,
	"./video/2023-breakingcircle-initial/26.webp": 82511,
	"./video/2023-breakingcircle-initial/27.webp": 81970,
	"./video/2023-breakingcircle-initial/28.webp": 48112,
	"./video/2023-breakingcircle-initial/29.webp": 86481,
	"./video/2023-breakingcircle-initial/30.webp": 50816,
	"./video/2023-breakingcircle-initial/31.webp": 12697,
	"./video/2023-breakingcircle-initial/32.webp": 57518,
	"./video/2023-breakingcircle-initial/33.webp": 6542,
	"./video/2023-breakingcircle-initial/34.webp": 57063,
	"./video/2023-breakingcircle-initial/35.webp": 67816,
	"./video/2023-breakingcircle-initial/36.webp": 85423,
	"./video/2023-breakingcircle-initial/37.webp": 21572,
	"./video/2023-breakingcircle-initial/38.webp": 94752,
	"./video/2023-breakingcircle-initial/39.webp": 34723,
	"./video/2023-breakingcircle-initial/40.webp": 85596,
	"./video/2023-breakingcircle-initial/41.webp": 18378,
	"./video/2023-breakingcircle-initial/42.webp": 23720,
	"./video/2023-breakingcircle-initial/43.webp": 6310,
	"./video/2023-breakingcircle-initial/44.webp": 55171,
	"./video/2023-breakingcircle-initial/45.webp": 78674,
	"./video/2023-breakingcircle-initial/46.webp": 8237,
	"./video/2023-breakingcircle-initial/47.webp": 60406,
	"./video/2023-breakingcircle-initial/48.webp": 12485,
	"./video/2023-breakingcircle-initial/49.webp": 62690,
	"./video/2023-breakingcircle-initial/50.webp": 48894,
	"./video/2023-breakingcircle-initial/51.webp": 49531,
	"./video/2023-breakingcircle-initial/52.webp": 27918,
	"./video/2023-breakingcircle-initial/53.webp": 26111,
	"./video/2023-earthfloater-idle.webm": 16072,
	"./video/2023-earthfloater-idle/00.webp": 31839,
	"./video/2023-earthfloater-idle/01.webp": 68824,
	"./video/2023-earthfloater-idle/02.webp": 96969,
	"./video/2023-earthfloater-idle/03.webp": 20645,
	"./video/2023-earthfloater-idle/04.webp": 17012,
	"./video/2023-earthfloater-idle/05.webp": 64446,
	"./video/2023-earthfloater-idle/06.webp": 3946,
	"./video/2023-earthfloater-idle/07.webp": 54895,
	"./video/2023-earthfloater-idle/08.webp": 69367,
	"./video/2023-earthfloater-idle/09.webp": 8870,
	"./video/2023-earthfloater-idle/10.webp": 57127,
	"./video/2023-earthfloater-idle/100.webp": 11938,
	"./video/2023-earthfloater-idle/101.webp": 66113,
	"./video/2023-earthfloater-idle/102.webp": 87433,
	"./video/2023-earthfloater-idle/103.webp": 3214,
	"./video/2023-earthfloater-idle/104.webp": 58364,
	"./video/2023-earthfloater-idle/105.webp": 86076,
	"./video/2023-earthfloater-idle/106.webp": 77658,
	"./video/2023-earthfloater-idle/107.webp": 86649,
	"./video/2023-earthfloater-idle/108.webp": 40838,
	"./video/2023-earthfloater-idle/109.webp": 68511,
	"./video/2023-earthfloater-idle/11.webp": 90854,
	"./video/2023-earthfloater-idle/110.webp": 59930,
	"./video/2023-earthfloater-idle/111.webp": 62781,
	"./video/2023-earthfloater-idle/112.webp": 13277,
	"./video/2023-earthfloater-idle/113.webp": 93631,
	"./video/2023-earthfloater-idle/114.webp": 83791,
	"./video/2023-earthfloater-idle/115.webp": 89165,
	"./video/2023-earthfloater-idle/116.webp": 76934,
	"./video/2023-earthfloater-idle/117.webp": 397,
	"./video/2023-earthfloater-idle/118.webp": 55682,
	"./video/2023-earthfloater-idle/119.webp": 86398,
	"./video/2023-earthfloater-idle/12.webp": 16518,
	"./video/2023-earthfloater-idle/120.webp": 40068,
	"./video/2023-earthfloater-idle/121.webp": 63193,
	"./video/2023-earthfloater-idle/122.webp": 22746,
	"./video/2023-earthfloater-idle/13.webp": 3332,
	"./video/2023-earthfloater-idle/14.webp": 7446,
	"./video/2023-earthfloater-idle/15.webp": 56245,
	"./video/2023-earthfloater-idle/16.webp": 75367,
	"./video/2023-earthfloater-idle/17.webp": 4591,
	"./video/2023-earthfloater-idle/18.webp": 77236,
	"./video/2023-earthfloater-idle/19.webp": 44842,
	"./video/2023-earthfloater-idle/20.webp": 54788,
	"./video/2023-earthfloater-idle/21.webp": 80480,
	"./video/2023-earthfloater-idle/22.webp": 17669,
	"./video/2023-earthfloater-idle/23.webp": 83659,
	"./video/2023-earthfloater-idle/24.webp": 5763,
	"./video/2023-earthfloater-idle/25.webp": 76151,
	"./video/2023-earthfloater-idle/26.webp": 233,
	"./video/2023-earthfloater-idle/27.webp": 91546,
	"./video/2023-earthfloater-idle/28.webp": 73489,
	"./video/2023-earthfloater-idle/29.webp": 7444,
	"./video/2023-earthfloater-idle/30.webp": 21657,
	"./video/2023-earthfloater-idle/31.webp": 94654,
	"./video/2023-earthfloater-idle/32.webp": 67022,
	"./video/2023-earthfloater-idle/33.webp": 61845,
	"./video/2023-earthfloater-idle/34.webp": 22751,
	"./video/2023-earthfloater-idle/35.webp": 41416,
	"./video/2023-earthfloater-idle/36.webp": 31596,
	"./video/2023-earthfloater-idle/37.webp": 2889,
	"./video/2023-earthfloater-idle/38.webp": 37117,
	"./video/2023-earthfloater-idle/39.webp": 4928,
	"./video/2023-earthfloater-idle/40.webp": 93898,
	"./video/2023-earthfloater-idle/41.webp": 74999,
	"./video/2023-earthfloater-idle/42.webp": 18717,
	"./video/2023-earthfloater-idle/43.webp": 5368,
	"./video/2023-earthfloater-idle/44.webp": 68870,
	"./video/2023-earthfloater-idle/45.webp": 7822,
	"./video/2023-earthfloater-idle/46.webp": 223,
	"./video/2023-earthfloater-idle/47.webp": 58537,
	"./video/2023-earthfloater-idle/48.webp": 13113,
	"./video/2023-earthfloater-idle/49.webp": 15927,
	"./video/2023-earthfloater-idle/50.webp": 30432,
	"./video/2023-earthfloater-idle/51.webp": 99147,
	"./video/2023-earthfloater-idle/52.webp": 56391,
	"./video/2023-earthfloater-idle/53.webp": 95454,
	"./video/2023-earthfloater-idle/54.webp": 33896,
	"./video/2023-earthfloater-idle/55.webp": 20021,
	"./video/2023-earthfloater-idle/56.webp": 5464,
	"./video/2023-earthfloater-idle/57.webp": 94952,
	"./video/2023-earthfloater-idle/58.webp": 17052,
	"./video/2023-earthfloater-idle/59.webp": 67190,
	"./video/2023-earthfloater-idle/60.webp": 98373,
	"./video/2023-earthfloater-idle/61.webp": 84584,
	"./video/2023-earthfloater-idle/62.webp": 4821,
	"./video/2023-earthfloater-idle/63.webp": 17867,
	"./video/2023-earthfloater-idle/64.webp": 98093,
	"./video/2023-earthfloater-idle/65.webp": 56596,
	"./video/2023-earthfloater-idle/66.webp": 13615,
	"./video/2023-earthfloater-idle/67.webp": 44293,
	"./video/2023-earthfloater-idle/68.webp": 91723,
	"./video/2023-earthfloater-idle/69.webp": 67335,
	"./video/2023-earthfloater-idle/70.webp": 30363,
	"./video/2023-earthfloater-idle/71.webp": 5202,
	"./video/2023-earthfloater-idle/72.webp": 83835,
	"./video/2023-earthfloater-idle/73.webp": 77524,
	"./video/2023-earthfloater-idle/74.webp": 62502,
	"./video/2023-earthfloater-idle/75.webp": 1103,
	"./video/2023-earthfloater-idle/76.webp": 99354,
	"./video/2023-earthfloater-idle/77.webp": 40519,
	"./video/2023-earthfloater-idle/78.webp": 88494,
	"./video/2023-earthfloater-idle/79.webp": 85501,
	"./video/2023-earthfloater-idle/80.webp": 21291,
	"./video/2023-earthfloater-idle/81.webp": 8588,
	"./video/2023-earthfloater-idle/82.webp": 85715,
	"./video/2023-earthfloater-idle/83.webp": 4359,
	"./video/2023-earthfloater-idle/84.webp": 76953,
	"./video/2023-earthfloater-idle/85.webp": 58977,
	"./video/2023-earthfloater-idle/86.webp": 73003,
	"./video/2023-earthfloater-idle/87.webp": 11602,
	"./video/2023-earthfloater-idle/88.webp": 2747,
	"./video/2023-earthfloater-idle/89.webp": 93766,
	"./video/2023-earthfloater-idle/90.webp": 54929,
	"./video/2023-earthfloater-idle/91.webp": 53108,
	"./video/2023-earthfloater-idle/92.webp": 81847,
	"./video/2023-earthfloater-idle/93.webp": 41073,
	"./video/2023-earthfloater-idle/94.webp": 48335,
	"./video/2023-earthfloater-idle/95.webp": 90257,
	"./video/2023-earthfloater-idle/96.webp": 95257,
	"./video/2023-earthfloater-idle/97.webp": 22855,
	"./video/2023-earthfloater-idle/98.webp": 6180,
	"./video/2023-earthfloater-idle/99.webp": 58865,
	"./video/2023-earthfloater-initial.webm": 77418,
	"./video/2023-earthfloater-initial/00.webp": 63344,
	"./video/2023-earthfloater-initial/01.webp": 55129,
	"./video/2023-earthfloater-initial/02.webp": 53850,
	"./video/2023-earthfloater-initial/03.webp": 57879,
	"./video/2023-earthfloater-initial/04.webp": 9635,
	"./video/2023-earthfloater-initial/05.webp": 22764,
	"./video/2023-earthfloater-initial/06.webp": 62873,
	"./video/2023-earthfloater-initial/07.webp": 89084,
	"./video/2023-earthfloater-initial/08.webp": 89785,
	"./video/2023-earthfloater-initial/09.webp": 27019,
	"./video/2023-earthfloater-initial/10.webp": 66503,
	"./video/2023-earthfloater-initial/11.webp": 8225,
	"./video/2023-earthfloater-initial/12.webp": 36291,
	"./video/2023-earthfloater-initial/13.webp": 95895,
	"./video/2023-earthfloater-initial/14.webp": 60910,
	"./video/2023-earthfloater-initial/15.webp": 92996,
	"./video/2023-earthfloater-initial/16.webp": 49742,
	"./video/2023-earthfloater-initial/17.webp": 19840,
	"./video/2023-earthfloater-initial/18.webp": 9183,
	"./video/2023-earthfloater-initial/19.webp": 11007,
	"./video/2023-earthfloater-initial/20.webp": 16099,
	"./video/2023-earthfloater-initial/21.webp": 6166,
	"./video/2023-earthfloater-initial/22.webp": 84223,
	"./video/2023-earthfloater-initial/23.webp": 72797,
	"./video/2023-earthfloater-initial/24.webp": 38730,
	"./video/2023-earthfloater-initial/25.webp": 871,
	"./video/2023-earthfloater-initial/26.webp": 98165,
	"./video/2023-earthfloater-initial/27.webp": 47243,
	"./video/2023-earthfloater-initial/28.webp": 7309,
	"./video/2023-earthfloater-initial/29.webp": 89073,
	"./video/2023-earthfloater-initial/30.webp": 92883,
	"./video/2023-earthfloater-initial/31.webp": 81307,
	"./video/2023-earthfloater-initial/32.webp": 56824,
	"./video/2023-earthfloater-initial/33.webp": 2145,
	"./video/2023-earthfloater-initial/34.webp": 69501,
	"./video/2023-earthfloater-initial/35.webp": 77771,
	"./video/2023-earthfloater-initial/36.webp": 78355,
	"./video/2023-earthfloater-initial/37.webp": 96333,
	"./video/2023-earthfloater-initial/38.webp": 38999,
	"./video/2023-earthfloater-initial/39.webp": 86769,
	"./video/2023-earthfloater-initial/40.webp": 99838,
	"./video/2023-earthfloater-initial/41.webp": 69128,
	"./video/2023-earthfloater-initial/42.webp": 9051,
	"./video/2023-earthfloater-initial/43.webp": 97359,
	"./video/2023-earthfloater-initial/44.webp": 44467,
	"./video/2023-earthfloater-initial/45.webp": 45435,
	"./video/2023-earthfloater-initial/46.webp": 17493,
	"./video/2023-earthfloater-initial/47.webp": 86841,
	"./video/2023-earthfloater-initial/48.webp": 29170,
	"./video/2023-earthfloater-initial/49.webp": 60257,
	"./video/2023-earthfloater-initial/50.webp": 84066,
	"./video/2023-earthfloater-initial/51.webp": 76397,
	"./video/2023-earthfloater-initial/52.webp": 5093,
	"./video/2023-earthfloater-initial/53.webp": 2874,
	"./video/2023-earthfloater-initial/54.webp": 25815,
	"./video/2023-earthfloater-initial/55.webp": 64336,
	"./video/2023-earthfloater-initial/56.webp": 648,
	"./video/2023-earthfloater-initial/57.webp": 50577,
	"./video/2023-earthfloater-initial/58.webp": 22444,
	"./video/2023-earthfloater-initial/59.webp": 81237,
	"./video/2023-earthfloater-initial/60.webp": 12393,
	"./video/2023-earthfloater-initial/61.webp": 89983,
	"./video/2023-earthfloater-initial/62.webp": 40365,
	"./video/2023-earthfloater-initial/63.webp": 14242,
	"./video/2023-earthfloater-initial/64.webp": 6536,
	"./video/2023-earthfloater-initial/65.webp": 6013,
	"./video/2023-earthfloater-initial/66.webp": 6042,
	"./video/2023-earthfloater-initial/67.webp": 33646,
	"./video/2023-earthfloater-initial/68.webp": 4385,
	"./video/2023-earthfloater-initial/69.webp": 97890,
	"./video/2023-ring-idle.webm": 75871,
	"./video/2023-ring-idle/00.webp": 6580,
	"./video/2023-ring-idle/01.webp": 75893,
	"./video/2023-ring-idle/02.webp": 24160,
	"./video/2023-ring-idle/03.webp": 78454,
	"./video/2023-ring-idle/04.webp": 27,
	"./video/2023-ring-idle/05.webp": 67650,
	"./video/2023-ring-idle/06.webp": 70281,
	"./video/2023-ring-idle/07.webp": 24567,
	"./video/2023-ring-idle/08.webp": 79288,
	"./video/2023-ring-idle/09.webp": 33474,
	"./video/2023-ring-idle/10.webp": 89920,
	"./video/2023-ring-idle/100.webp": 42321,
	"./video/2023-ring-idle/101.webp": 77904,
	"./video/2023-ring-idle/102.webp": 60305,
	"./video/2023-ring-idle/103.webp": 29278,
	"./video/2023-ring-idle/104.webp": 93791,
	"./video/2023-ring-idle/105.webp": 15353,
	"./video/2023-ring-idle/106.webp": 54714,
	"./video/2023-ring-idle/107.webp": 36193,
	"./video/2023-ring-idle/108.webp": 19123,
	"./video/2023-ring-idle/109.webp": 78690,
	"./video/2023-ring-idle/11.webp": 96698,
	"./video/2023-ring-idle/110.webp": 30304,
	"./video/2023-ring-idle/111.webp": 73853,
	"./video/2023-ring-idle/112.webp": 28244,
	"./video/2023-ring-idle/113.webp": 68988,
	"./video/2023-ring-idle/114.webp": 88304,
	"./video/2023-ring-idle/115.webp": 54432,
	"./video/2023-ring-idle/116.webp": 87303,
	"./video/2023-ring-idle/117.webp": 91588,
	"./video/2023-ring-idle/118.webp": 96853,
	"./video/2023-ring-idle/119.webp": 71177,
	"./video/2023-ring-idle/12.webp": 91212,
	"./video/2023-ring-idle/120.webp": 22537,
	"./video/2023-ring-idle/121.webp": 11428,
	"./video/2023-ring-idle/122.webp": 76509,
	"./video/2023-ring-idle/123.webp": 59346,
	"./video/2023-ring-idle/124.webp": 91333,
	"./video/2023-ring-idle/125.webp": 44986,
	"./video/2023-ring-idle/126.webp": 90248,
	"./video/2023-ring-idle/127.webp": 85227,
	"./video/2023-ring-idle/128.webp": 73307,
	"./video/2023-ring-idle/129.webp": 2258,
	"./video/2023-ring-idle/13.webp": 6606,
	"./video/2023-ring-idle/130.webp": 68462,
	"./video/2023-ring-idle/131.webp": 43297,
	"./video/2023-ring-idle/132.webp": 55841,
	"./video/2023-ring-idle/133.webp": 51736,
	"./video/2023-ring-idle/134.webp": 37153,
	"./video/2023-ring-idle/135.webp": 78460,
	"./video/2023-ring-idle/136.webp": 96899,
	"./video/2023-ring-idle/137.webp": 12260,
	"./video/2023-ring-idle/138.webp": 40504,
	"./video/2023-ring-idle/139.webp": 98221,
	"./video/2023-ring-idle/14.webp": 29555,
	"./video/2023-ring-idle/140.webp": 80563,
	"./video/2023-ring-idle/141.webp": 90031,
	"./video/2023-ring-idle/142.webp": 68645,
	"./video/2023-ring-idle/143.webp": 59530,
	"./video/2023-ring-idle/15.webp": 20442,
	"./video/2023-ring-idle/16.webp": 23007,
	"./video/2023-ring-idle/17.webp": 13657,
	"./video/2023-ring-idle/18.webp": 64262,
	"./video/2023-ring-idle/19.webp": 52061,
	"./video/2023-ring-idle/20.webp": 94947,
	"./video/2023-ring-idle/21.webp": 8723,
	"./video/2023-ring-idle/22.webp": 57128,
	"./video/2023-ring-idle/23.webp": 27663,
	"./video/2023-ring-idle/24.webp": 29987,
	"./video/2023-ring-idle/25.webp": 2773,
	"./video/2023-ring-idle/26.webp": 40655,
	"./video/2023-ring-idle/27.webp": 93130,
	"./video/2023-ring-idle/28.webp": 22481,
	"./video/2023-ring-idle/29.webp": 83559,
	"./video/2023-ring-idle/30.webp": 60353,
	"./video/2023-ring-idle/31.webp": 20034,
	"./video/2023-ring-idle/32.webp": 71166,
	"./video/2023-ring-idle/33.webp": 69280,
	"./video/2023-ring-idle/34.webp": 24933,
	"./video/2023-ring-idle/35.webp": 54604,
	"./video/2023-ring-idle/36.webp": 53196,
	"./video/2023-ring-idle/37.webp": 84592,
	"./video/2023-ring-idle/38.webp": 95753,
	"./video/2023-ring-idle/39.webp": 3414,
	"./video/2023-ring-idle/40.webp": 36854,
	"./video/2023-ring-idle/41.webp": 57996,
	"./video/2023-ring-idle/42.webp": 91202,
	"./video/2023-ring-idle/43.webp": 35932,
	"./video/2023-ring-idle/44.webp": 5609,
	"./video/2023-ring-idle/45.webp": 60148,
	"./video/2023-ring-idle/46.webp": 53845,
	"./video/2023-ring-idle/47.webp": 39137,
	"./video/2023-ring-idle/48.webp": 36994,
	"./video/2023-ring-idle/49.webp": 84152,
	"./video/2023-ring-idle/50.webp": 14001,
	"./video/2023-ring-idle/51.webp": 55564,
	"./video/2023-ring-idle/52.webp": 60733,
	"./video/2023-ring-idle/53.webp": 17350,
	"./video/2023-ring-idle/54.webp": 88211,
	"./video/2023-ring-idle/55.webp": 2905,
	"./video/2023-ring-idle/56.webp": 98795,
	"./video/2023-ring-idle/57.webp": 54839,
	"./video/2023-ring-idle/58.webp": 55193,
	"./video/2023-ring-idle/59.webp": 57439,
	"./video/2023-ring-idle/60.webp": 87505,
	"./video/2023-ring-idle/61.webp": 57206,
	"./video/2023-ring-idle/62.webp": 67049,
	"./video/2023-ring-idle/63.webp": 91639,
	"./video/2023-ring-idle/64.webp": 17064,
	"./video/2023-ring-idle/65.webp": 291,
	"./video/2023-ring-idle/66.webp": 60235,
	"./video/2023-ring-idle/67.webp": 94399,
	"./video/2023-ring-idle/68.webp": 22575,
	"./video/2023-ring-idle/69.webp": 15991,
	"./video/2023-ring-idle/70.webp": 27144,
	"./video/2023-ring-idle/71.webp": 31474,
	"./video/2023-ring-idle/72.webp": 21200,
	"./video/2023-ring-idle/73.webp": 25685,
	"./video/2023-ring-idle/74.webp": 81701,
	"./video/2023-ring-idle/75.webp": 90720,
	"./video/2023-ring-idle/76.webp": 8892,
	"./video/2023-ring-idle/77.webp": 62714,
	"./video/2023-ring-idle/78.webp": 18120,
	"./video/2023-ring-idle/79.webp": 68720,
	"./video/2023-ring-idle/80.webp": 64815,
	"./video/2023-ring-idle/81.webp": 90027,
	"./video/2023-ring-idle/82.webp": 61812,
	"./video/2023-ring-idle/83.webp": 92894,
	"./video/2023-ring-idle/84.webp": 31875,
	"./video/2023-ring-idle/85.webp": 20157,
	"./video/2023-ring-idle/86.webp": 52938,
	"./video/2023-ring-idle/87.webp": 40924,
	"./video/2023-ring-idle/88.webp": 96526,
	"./video/2023-ring-idle/89.webp": 81871,
	"./video/2023-ring-idle/90.webp": 18434,
	"./video/2023-ring-idle/91.webp": 5705,
	"./video/2023-ring-idle/92.webp": 69035,
	"./video/2023-ring-idle/93.webp": 46980,
	"./video/2023-ring-idle/94.webp": 40799,
	"./video/2023-ring-idle/95.webp": 42860,
	"./video/2023-ring-idle/96.webp": 12601,
	"./video/2023-ring-idle/97.webp": 28775,
	"./video/2023-ring-idle/98.webp": 41209,
	"./video/2023-ring-idle/99.webp": 24333,
	"./video/2023-ring-initial.webm": 42782,
	"./video/2023-ring-initial/00.webp": 9432,
	"./video/2023-ring-initial/01.webp": 3914,
	"./video/2023-ring-initial/02.webp": 3522,
	"./video/2023-ring-initial/03.webp": 88299,
	"./video/2023-ring-initial/04.webp": 15814,
	"./video/2023-ring-initial/05.webp": 15943,
	"./video/2023-ring-initial/06.webp": 56633,
	"./video/2023-ring-initial/07.webp": 43844,
	"./video/2023-ring-initial/08.webp": 30014,
	"./video/2023-ring-initial/09.webp": 56823,
	"./video/2023-ring-initial/10.webp": 55642,
	"./video/2023-ring-initial/11.webp": 15193,
	"./video/2023-ring-initial/12.webp": 39958,
	"./video/2023-ring-initial/13.webp": 326,
	"./video/2023-ring-initial/14.webp": 34017,
	"./video/2023-ring-initial/15.webp": 35086,
	"./video/2023-ring-initial/16.webp": 15179,
	"./video/2023-ring-initial/17.webp": 44313,
	"./video/2023-ring-initial/18.webp": 12467,
	"./video/2023-ring-initial/19.webp": 84396,
	"./video/2023-ring-initial/20.webp": 31087,
	"./video/2023-ring-initial/21.webp": 60287,
	"./video/2023-ring-initial/22.webp": 78649,
	"./video/2023-ring-initial/23.webp": 30161,
	"./video/2023-ring-initial/24.webp": 68530,
	"./video/2023-ring-initial/25.webp": 82841,
	"./video/2023-ring-initial/26.webp": 54114,
	"./video/2023-ring-initial/27.webp": 18124,
	"./video/2023-ring-initial/28.webp": 40074,
	"./video/2023-ring-initial/29.webp": 18662,
	"./video/2023-ring-initial/30.webp": 73573,
	"./video/2023-ring-initial/31.webp": 50655,
	"./video/2023-ring-initial/32.webp": 94590,
	"./video/2023-ring-initial/33.webp": 61044,
	"./video/2023-ring-initial/34.webp": 19333,
	"./video/2023-ring-initial/35.webp": 88163,
	"./video/2023-ring-initial/36.webp": 91123,
	"./video/2023-ring-initial/37.webp": 4085,
	"./video/2023-ring-initial/38.webp": 15143,
	"./video/2023-ring-initial/39.webp": 95531,
	"./video/2023-ring-initial/40.webp": 7136,
	"./video/2023-ring-initial/41.webp": 13820,
	"./video/2023-ring-initial/42.webp": 44266,
	"./video/2023-ring-initial/43.webp": 50643,
	"./video/2023-ring-initial/44.webp": 15390,
	"./video/2023-ring-initial/45.webp": 81205,
	"./video/2023-ring-initial/46.webp": 64081,
	"./video/2023-ring-initial/47.webp": 69999,
	"./video/2023-ring-initial/48.webp": 26446,
	"./video/future-clouds.webm": 8044,
	"./video/future-clouds/00.webp": 77667,
	"./video/future-clouds/01.webp": 83702,
	"./video/future-clouds/02.webp": 29152,
	"./video/future-clouds/03.webp": 68901,
	"./video/future-clouds/04.webp": 41236,
	"./video/future-clouds/05.webp": 53443,
	"./video/future-clouds/06.webp": 86536,
	"./video/future-clouds/07.webp": 52723,
	"./video/future-clouds/08.webp": 65732,
	"./video/future-clouds/09.webp": 35782,
	"./video/future-clouds/10.webp": 12746,
	"./video/future-clouds/11.webp": 6252,
	"./video/future-clouds/12.webp": 57662,
	"./video/future-clouds/13.webp": 21216,
	"./video/future-clouds/14.webp": 14773,
	"./video/future-clouds/15.webp": 62673,
	"./video/future-clouds/16.webp": 15500,
	"./video/future-clouds/17.webp": 76477,
	"./video/future-clouds/18.webp": 34743,
	"./video/future-clouds/19.webp": 28861,
	"./video/future-clouds/20.webp": 78553,
	"./video/future-clouds/21.webp": 66286,
	"./video/future-clouds/22.webp": 80454,
	"./video/future-clouds/23.webp": 41499,
	"./video/future-clouds/24.webp": 21308,
	"./video/future-clouds/25.webp": 74111,
	"./video/future-clouds/26.webp": 72685,
	"./video/future-clouds/27.webp": 58235,
	"./video/future-clouds/28.webp": 25557,
	"./video/future-clouds/29.webp": 51879,
	"./video/future-clouds/30.webp": 40480,
	"./video/future-clouds/31.webp": 85261,
	"./video/future-clouds/32.webp": 84546,
	"./video/future-clouds/33.webp": 85,
	"./video/future-clouds/34.webp": 74584,
	"./video/future-clouds/35.webp": 44831,
	"./video/future-clouds/36.webp": 26813,
	"./video/future-clouds/37.webp": 78358,
	"./video/future-clouds/38.webp": 23737,
	"./video/future-clouds/39.webp": 78395,
	"./video/future-clouds/40.webp": 7156,
	"./video/future-clouds/41.webp": 8635,
	"./video/future-clouds/42.webp": 66115,
	"./video/future-clouds/43.webp": 82761,
	"./video/future-clouds/44.webp": 55846,
	"./video/future-clouds/45.webp": 15000,
	"./video/future-clouds/46.webp": 68896,
	"./video/future-clouds/47.webp": 8824,
	"./video/future-clouds/48.webp": 88972,
	"./video/future-clouds/49.webp": 83271,
	"./video/future-clouds/50.webp": 11685,
	"./video/future-clouds/51.webp": 95169,
	"./video/future-clouds/52.webp": 25192,
	"./video/future-clouds/53.webp": 14497,
	"./video/future-clouds/54.webp": 65521,
	"./video/future-clouds/55.webp": 56647,
	"./video/future-clouds/56.webp": 93567,
	"./video/future-clouds/57.webp": 92828,
	"./video/future-clouds/58.webp": 32707,
	"./video/future-clouds/59.webp": 4284,
	"./video/future-clouds/60.webp": 56974,
	"./video/future-clouds/61.webp": 41619,
	"./video/future-clouds/62.webp": 69398,
	"./video/future-clouds/63.webp": 2149,
	"./video/future-clouds/64.webp": 63146,
	"./video/future-clouds/65.webp": 1870,
	"./video/future-clouds/66.webp": 32231,
	"./video/future-clouds/67.webp": 12510,
	"./video/future-clouds/68.webp": 73803,
	"./video/future-clouds/69.webp": 7498,
	"./video/future-clouds/70.webp": 49140,
	"./video/future-clouds/71.webp": 11698,
	"./video/future-clouds/72.webp": 88411,
	"./video/future-clouds/73.webp": 11951,
	"./video/future-clouds/74.webp": 9600,
	"./video/future-clouds/75.webp": 20766,
	"./video/future-clouds/76.webp": 70190,
	"./video/future-clouds/77.webp": 24605,
	"./video/future-clouds/78.webp": 51163,
	"./video/future-clouds/79.webp": 20453,
	"./video/future-clouds/80.webp": 65077,
	"./video/future-clouds/81.webp": 20422,
	"./video/future-clouds/82.webp": 96785,
	"./video/future-clouds/83.webp": 14990,
	"./video/future-clouds/84.webp": 12292,
	"./video/future-clouds/85.webp": 24079,
	"./video/future-clouds/86.webp": 50251,
	"./video/future-clouds/87.webp": 40630,
	"./video/future-clouds/88.webp": 92256,
	"./video/future-clouds/89.webp": 72453,
	"./video/future-clouds/90.webp": 91675,
	"./video/future-clouds/91.webp": 57196,
	"./video/future-clouds/92.webp": 66957,
	"./video/future-clouds/93.webp": 10633,
	"./video/future-clouds/94.webp": 36945,
	"./video/future-clouds/95.webp": 65959,
	"./video/future-clouds/96.webp": 27657,
	"./video/future-idle.webm": 47429,
	"./video/future-idle/00.webp": 93892,
	"./video/future-idle/01.webp": 12531,
	"./video/future-idle/02.webp": 10331,
	"./video/future-idle/03.webp": 77028,
	"./video/future-idle/04.webp": 22399,
	"./video/future-idle/05.webp": 93084,
	"./video/future-idle/06.webp": 83319,
	"./video/future-idle/07.webp": 85243,
	"./video/future-idle/08.webp": 62921,
	"./video/future-idle/09.webp": 84880,
	"./video/future-idle/10.webp": 52108,
	"./video/future-idle/11.webp": 5166,
	"./video/future-idle/12.webp": 58154,
	"./video/future-idle/13.webp": 68743,
	"./video/future-idle/14.webp": 21674,
	"./video/future-idle/15.webp": 80372,
	"./video/future-idle/16.webp": 22745,
	"./video/future-idle/17.webp": 63339,
	"./video/future-idle/18.webp": 93142,
	"./video/future-idle/19.webp": 89878,
	"./video/future-idle/20.webp": 34564,
	"./video/future-idle/21.webp": 9227,
	"./video/future-idle/22.webp": 16308,
	"./video/future-idle/23.webp": 15900,
	"./video/future-idle/24.webp": 88723,
	"./video/future-idle/25.webp": 1747,
	"./video/future-idle/26.webp": 78607,
	"./video/future-idle/27.webp": 84595,
	"./video/future-idle/28.webp": 7359,
	"./video/future-idle/29.webp": 31550,
	"./video/future-idle/30.webp": 76410,
	"./video/future-idle/31.webp": 45134,
	"./video/future-idle/32.webp": 11903,
	"./video/future-idle/33.webp": 42570,
	"./video/future-idle/34.webp": 66473,
	"./video/future-idle/35.webp": 13299,
	"./video/future-idle/36.webp": 52443,
	"./video/future-idle/37.webp": 91261,
	"./video/future-idle/38.webp": 4145,
	"./video/future-idle/39.webp": 56876,
	"./video/future-idle/40.webp": 93891,
	"./video/future-idle/41.webp": 86809,
	"./video/future-idle/42.webp": 78206,
	"./video/future-idle/43.webp": 99072,
	"./video/future-idle/44.webp": 83446,
	"./video/future-idle/45.webp": 98743,
	"./video/future-idle/46.webp": 35838,
	"./video/future-idle/47.webp": 62373,
	"./video/future-idle/48.webp": 98526,
	"./video/future-initial.webm": 30965,
	"./video/future-initial/00.webp": 25773,
	"./video/future-initial/01.webp": 51893,
	"./video/future-initial/02.webp": 99340,
	"./video/future-initial/03.webp": 9819,
	"./video/future-initial/04.webp": 76418,
	"./video/future-initial/05.webp": 60298,
	"./video/future-initial/06.webp": 17459,
	"./video/future-initial/07.webp": 48800,
	"./video/future-initial/08.webp": 76454,
	"./video/future-initial/09.webp": 32346,
	"./video/future-initial/10.webp": 84987,
	"./video/future-initial/11.webp": 40325,
	"./video/future-initial/12.webp": 48425,
	"./video/future-initial/13.webp": 16983,
	"./video/future-initial/14.webp": 71085,
	"./video/future-initial/15.webp": 79037,
	"./video/future-initial/16.webp": 83064,
	"./video/future-initial/17.webp": 53699,
	"./video/future-initial/18.webp": 9550,
	"./video/future-initial/19.webp": 67598,
	"./video/future-initial/20.webp": 88491,
	"./video/future-initial/21.webp": 5095,
	"./video/future-initial/22.webp": 19863,
	"./video/future-initial/23.webp": 7013,
	"./video/future-initial/24.webp": 19928,
	"./video/future-initial/25.webp": 40512,
	"./video/future-initial/26.webp": 84593,
	"./video/future-initial/27.webp": 74360,
	"./video/future-initial/28.webp": 27169,
	"./video/future-initial/29.webp": 56156,
	"./video/future-initial/30.webp": 26923,
	"./video/future-initial/31.webp": 46257,
	"./video/future-initial/32.webp": 40465,
	"./video/future-initial/33.webp": 47284,
	"./video/future-initial/34.webp": 9035,
	"./video/future-initial/35.webp": 31475,
	"./video/future-initial/36.webp": 18877,
	"./video/future-initial/37.webp": 56426,
	"./video/future-initial/38.webp": 10324,
	"./video/future-initial/39.webp": 79121,
	"./video/future-initial/40.webp": 55782,
	"./video/future-initial/41.webp": 76297,
	"./video/future-initial/42.webp": 46209,
	"./video/future-initial/43.webp": 28977,
	"./video/future-initial/44.webp": 14625,
	"./video/future-initial/45.webp": 97532,
	"./video/future-initial/46.webp": 89770,
	"./video/future-initial/47.webp": 62375,
	"./video/general/wordmark.webm": 51491,
	"./video/overview-shapeofchange-loop.webm": 96077,
	"./video/overview-shapeofchange-loop/00.webp": 19388,
	"./video/overview-shapeofchange-loop/01.webp": 827,
	"./video/overview-shapeofchange-loop/02.webp": 66629,
	"./video/overview-shapeofchange-loop/03.webp": 89992,
	"./video/overview-shapeofchange-loop/04.webp": 58749,
	"./video/overview-shapeofchange-loop/05.webp": 65882,
	"./video/overview-shapeofchange-loop/06.webp": 15911,
	"./video/overview-shapeofchange-loop/07.webp": 49860,
	"./video/overview-shapeofchange-loop/08.webp": 69118,
	"./video/overview-shapeofchange-loop/09.webp": 57718,
	"./video/overview-shapeofchange-loop/10.webp": 77606,
	"./video/overview-shapeofchange-loop/100.webp": 28545,
	"./video/overview-shapeofchange-loop/101.webp": 46695,
	"./video/overview-shapeofchange-loop/102.webp": 54273,
	"./video/overview-shapeofchange-loop/103.webp": 33018,
	"./video/overview-shapeofchange-loop/11.webp": 43519,
	"./video/overview-shapeofchange-loop/12.webp": 32212,
	"./video/overview-shapeofchange-loop/13.webp": 32912,
	"./video/overview-shapeofchange-loop/14.webp": 94316,
	"./video/overview-shapeofchange-loop/15.webp": 54449,
	"./video/overview-shapeofchange-loop/16.webp": 61199,
	"./video/overview-shapeofchange-loop/17.webp": 49779,
	"./video/overview-shapeofchange-loop/18.webp": 63192,
	"./video/overview-shapeofchange-loop/19.webp": 71345,
	"./video/overview-shapeofchange-loop/20.webp": 28794,
	"./video/overview-shapeofchange-loop/21.webp": 36382,
	"./video/overview-shapeofchange-loop/22.webp": 24967,
	"./video/overview-shapeofchange-loop/23.webp": 38157,
	"./video/overview-shapeofchange-loop/24.webp": 10811,
	"./video/overview-shapeofchange-loop/25.webp": 43245,
	"./video/overview-shapeofchange-loop/26.webp": 49274,
	"./video/overview-shapeofchange-loop/27.webp": 83410,
	"./video/overview-shapeofchange-loop/28.webp": 77164,
	"./video/overview-shapeofchange-loop/29.webp": 99575,
	"./video/overview-shapeofchange-loop/30.webp": 63465,
	"./video/overview-shapeofchange-loop/31.webp": 19851,
	"./video/overview-shapeofchange-loop/32.webp": 90484,
	"./video/overview-shapeofchange-loop/33.webp": 46201,
	"./video/overview-shapeofchange-loop/34.webp": 98044,
	"./video/overview-shapeofchange-loop/35.webp": 43042,
	"./video/overview-shapeofchange-loop/36.webp": 10121,
	"./video/overview-shapeofchange-loop/37.webp": 13928,
	"./video/overview-shapeofchange-loop/38.webp": 67807,
	"./video/overview-shapeofchange-loop/39.webp": 10180,
	"./video/overview-shapeofchange-loop/40.webp": 57576,
	"./video/overview-shapeofchange-loop/41.webp": 35926,
	"./video/overview-shapeofchange-loop/42.webp": 88602,
	"./video/overview-shapeofchange-loop/43.webp": 46329,
	"./video/overview-shapeofchange-loop/44.webp": 7485,
	"./video/overview-shapeofchange-loop/45.webp": 67115,
	"./video/overview-shapeofchange-loop/46.webp": 68085,
	"./video/overview-shapeofchange-loop/47.webp": 62764,
	"./video/overview-shapeofchange-loop/48.webp": 14376,
	"./video/overview-shapeofchange-loop/49.webp": 51149,
	"./video/overview-shapeofchange-loop/50.webp": 19625,
	"./video/overview-shapeofchange-loop/51.webp": 75312,
	"./video/overview-shapeofchange-loop/52.webp": 68647,
	"./video/overview-shapeofchange-loop/53.webp": 82393,
	"./video/overview-shapeofchange-loop/54.webp": 86372,
	"./video/overview-shapeofchange-loop/55.webp": 3404,
	"./video/overview-shapeofchange-loop/56.webp": 14714,
	"./video/overview-shapeofchange-loop/57.webp": 77372,
	"./video/overview-shapeofchange-loop/58.webp": 1798,
	"./video/overview-shapeofchange-loop/59.webp": 94869,
	"./video/overview-shapeofchange-loop/60.webp": 68873,
	"./video/overview-shapeofchange-loop/61.webp": 35549,
	"./video/overview-shapeofchange-loop/62.webp": 79180,
	"./video/overview-shapeofchange-loop/63.webp": 2099,
	"./video/overview-shapeofchange-loop/64.webp": 28601,
	"./video/overview-shapeofchange-loop/65.webp": 73668,
	"./video/overview-shapeofchange-loop/66.webp": 25303,
	"./video/overview-shapeofchange-loop/67.webp": 49959,
	"./video/overview-shapeofchange-loop/68.webp": 5143,
	"./video/overview-shapeofchange-loop/69.webp": 60382,
	"./video/overview-shapeofchange-loop/70.webp": 9614,
	"./video/overview-shapeofchange-loop/71.webp": 67327,
	"./video/overview-shapeofchange-loop/72.webp": 36417,
	"./video/overview-shapeofchange-loop/73.webp": 27373,
	"./video/overview-shapeofchange-loop/74.webp": 53335,
	"./video/overview-shapeofchange-loop/75.webp": 46521,
	"./video/overview-shapeofchange-loop/76.webp": 27368,
	"./video/overview-shapeofchange-loop/77.webp": 95945,
	"./video/overview-shapeofchange-loop/78.webp": 46841,
	"./video/overview-shapeofchange-loop/79.webp": 57917,
	"./video/overview-shapeofchange-loop/80.webp": 22211,
	"./video/overview-shapeofchange-loop/81.webp": 99480,
	"./video/overview-shapeofchange-loop/82.webp": 21959,
	"./video/overview-shapeofchange-loop/83.webp": 18420,
	"./video/overview-shapeofchange-loop/84.webp": 36086,
	"./video/overview-shapeofchange-loop/85.webp": 86547,
	"./video/overview-shapeofchange-loop/86.webp": 99764,
	"./video/overview-shapeofchange-loop/87.webp": 86933,
	"./video/overview-shapeofchange-loop/88.webp": 80899,
	"./video/overview-shapeofchange-loop/89.webp": 32323,
	"./video/overview-shapeofchange-loop/90.webp": 17645,
	"./video/overview-shapeofchange-loop/91.webp": 48738,
	"./video/overview-shapeofchange-loop/92.webp": 77885,
	"./video/overview-shapeofchange-loop/93.webp": 7619,
	"./video/overview-shapeofchange-loop/94.webp": 88433,
	"./video/overview-shapeofchange-loop/95.webp": 18480,
	"./video/overview-shapeofchange-loop/96.webp": 49228,
	"./video/overview-shapeofchange-loop/97.webp": 89955,
	"./video/overview-shapeofchange-loop/98.webp": 6860,
	"./video/overview-shapeofchange-loop/99.webp": 5435,
	"./video/overview-shapeofchange-mask.webm": 60546,
	"./video/overview-shapeofchange-mask/00.webp": 74763,
	"./video/overview-shapeofchange-mask/01.webp": 48118,
	"./video/overview-shapeofchange-mask/02.webp": 86346,
	"./video/overview-shapeofchange-mask/03.webp": 47543,
	"./video/overview-shapeofchange-mask/04.webp": 87914,
	"./video/overview-shapeofchange-mask/05.webp": 94617,
	"./video/overview-shapeofchange-mask/06.webp": 68489,
	"./video/overview-shapeofchange-mask/07.webp": 23991,
	"./video/overview-shapeofchange-mask/08.webp": 75682,
	"./video/overview-shapeofchange-mask/09.webp": 71495,
	"./video/overview-shapeofchange-mask/10.webp": 64509,
	"./video/overview-shapeofchange-mask/100.webp": 13291,
	"./video/overview-shapeofchange-mask/101.webp": 32852,
	"./video/overview-shapeofchange-mask/102.webp": 89761,
	"./video/overview-shapeofchange-mask/103.webp": 56693,
	"./video/overview-shapeofchange-mask/11.webp": 22750,
	"./video/overview-shapeofchange-mask/12.webp": 3959,
	"./video/overview-shapeofchange-mask/13.webp": 14478,
	"./video/overview-shapeofchange-mask/14.webp": 30728,
	"./video/overview-shapeofchange-mask/15.webp": 78957,
	"./video/overview-shapeofchange-mask/16.webp": 20194,
	"./video/overview-shapeofchange-mask/17.webp": 98104,
	"./video/overview-shapeofchange-mask/18.webp": 55754,
	"./video/overview-shapeofchange-mask/19.webp": 17902,
	"./video/overview-shapeofchange-mask/20.webp": 64131,
	"./video/overview-shapeofchange-mask/21.webp": 88696,
	"./video/overview-shapeofchange-mask/22.webp": 99270,
	"./video/overview-shapeofchange-mask/23.webp": 81789,
	"./video/overview-shapeofchange-mask/24.webp": 17121,
	"./video/overview-shapeofchange-mask/25.webp": 88810,
	"./video/overview-shapeofchange-mask/26.webp": 28164,
	"./video/overview-shapeofchange-mask/27.webp": 62634,
	"./video/overview-shapeofchange-mask/28.webp": 6355,
	"./video/overview-shapeofchange-mask/29.webp": 51849,
	"./video/overview-shapeofchange-mask/30.webp": 35579,
	"./video/overview-shapeofchange-mask/31.webp": 89309,
	"./video/overview-shapeofchange-mask/32.webp": 52432,
	"./video/overview-shapeofchange-mask/33.webp": 71327,
	"./video/overview-shapeofchange-mask/34.webp": 34443,
	"./video/overview-shapeofchange-mask/35.webp": 14863,
	"./video/overview-shapeofchange-mask/36.webp": 973,
	"./video/overview-shapeofchange-mask/37.webp": 94667,
	"./video/overview-shapeofchange-mask/38.webp": 11663,
	"./video/overview-shapeofchange-mask/39.webp": 36691,
	"./video/overview-shapeofchange-mask/40.webp": 7436,
	"./video/overview-shapeofchange-mask/41.webp": 82641,
	"./video/overview-shapeofchange-mask/42.webp": 46508,
	"./video/overview-shapeofchange-mask/43.webp": 46986,
	"./video/overview-shapeofchange-mask/44.webp": 49062,
	"./video/overview-shapeofchange-mask/45.webp": 69317,
	"./video/overview-shapeofchange-mask/46.webp": 68369,
	"./video/overview-shapeofchange-mask/47.webp": 2362,
	"./video/overview-shapeofchange-mask/48.webp": 3221,
	"./video/overview-shapeofchange-mask/49.webp": 53899,
	"./video/overview-shapeofchange-mask/50.webp": 40346,
	"./video/overview-shapeofchange-mask/51.webp": 50608,
	"./video/overview-shapeofchange-mask/52.webp": 96579,
	"./video/overview-shapeofchange-mask/53.webp": 21671,
	"./video/overview-shapeofchange-mask/54.webp": 82278,
	"./video/overview-shapeofchange-mask/55.webp": 5283,
	"./video/overview-shapeofchange-mask/56.webp": 55285,
	"./video/overview-shapeofchange-mask/57.webp": 9493,
	"./video/overview-shapeofchange-mask/58.webp": 4617,
	"./video/overview-shapeofchange-mask/59.webp": 5511,
	"./video/overview-shapeofchange-mask/60.webp": 13806,
	"./video/overview-shapeofchange-mask/61.webp": 1495,
	"./video/overview-shapeofchange-mask/62.webp": 88497,
	"./video/overview-shapeofchange-mask/63.webp": 3091,
	"./video/overview-shapeofchange-mask/64.webp": 25184,
	"./video/overview-shapeofchange-mask/65.webp": 19962,
	"./video/overview-shapeofchange-mask/66.webp": 70015,
	"./video/overview-shapeofchange-mask/67.webp": 80880,
	"./video/overview-shapeofchange-mask/68.webp": 11034,
	"./video/overview-shapeofchange-mask/69.webp": 31009,
	"./video/overview-shapeofchange-mask/70.webp": 78347,
	"./video/overview-shapeofchange-mask/71.webp": 34503,
	"./video/overview-shapeofchange-mask/72.webp": 45525,
	"./video/overview-shapeofchange-mask/73.webp": 48724,
	"./video/overview-shapeofchange-mask/74.webp": 18822,
	"./video/overview-shapeofchange-mask/75.webp": 431,
	"./video/overview-shapeofchange-mask/76.webp": 74481,
	"./video/overview-shapeofchange-mask/77.webp": 38714,
	"./video/overview-shapeofchange-mask/78.webp": 65181,
	"./video/overview-shapeofchange-mask/79.webp": 39761,
	"./video/overview-shapeofchange-mask/80.webp": 16905,
	"./video/overview-shapeofchange-mask/81.webp": 15700,
	"./video/overview-shapeofchange-mask/82.webp": 38977,
	"./video/overview-shapeofchange-mask/83.webp": 34187,
	"./video/overview-shapeofchange-mask/84.webp": 69079,
	"./video/overview-shapeofchange-mask/85.webp": 84967,
	"./video/overview-shapeofchange-mask/86.webp": 87468,
	"./video/overview-shapeofchange-mask/87.webp": 8511,
	"./video/overview-shapeofchange-mask/88.webp": 93537,
	"./video/overview-shapeofchange-mask/89.webp": 96695,
	"./video/overview-shapeofchange-mask/90.webp": 32326,
	"./video/overview-shapeofchange-mask/91.webp": 22450,
	"./video/overview-shapeofchange-mask/92.webp": 74539,
	"./video/overview-shapeofchange-mask/93.webp": 30276,
	"./video/overview-shapeofchange-mask/94.webp": 88186,
	"./video/overview-shapeofchange-mask/95.webp": 51032,
	"./video/overview-shapeofchange-mask/96.webp": 18529,
	"./video/overview-shapeofchange-mask/97.webp": 51851,
	"./video/overview-shapeofchange-mask/98.webp": 34105,
	"./video/overview-shapeofchange-mask/99.webp": 62668,
	"./video/people-balance-idle.webm": 37786,
	"./video/people-balance-idle/00.webp": 78191,
	"./video/people-balance-idle/01.webp": 89503,
	"./video/people-balance-idle/02.webp": 90526,
	"./video/people-balance-idle/03.webp": 24990,
	"./video/people-balance-idle/04.webp": 46970,
	"./video/people-balance-idle/05.webp": 67761,
	"./video/people-balance-idle/06.webp": 22512,
	"./video/people-balance-idle/07.webp": 99272,
	"./video/people-balance-idle/08.webp": 92684,
	"./video/people-balance-idle/09.webp": 92137,
	"./video/people-balance-idle/10.webp": 29207,
	"./video/people-balance-idle/11.webp": 51398,
	"./video/people-balance-idle/12.webp": 78484,
	"./video/people-balance-idle/13.webp": 84933,
	"./video/people-balance-idle/14.webp": 11991,
	"./video/people-balance-idle/15.webp": 99188,
	"./video/people-balance-idle/16.webp": 46854,
	"./video/people-balance-idle/17.webp": 89379,
	"./video/people-balance-idle/18.webp": 72680,
	"./video/people-balance-idle/19.webp": 40991,
	"./video/people-balance-idle/20.webp": 53353,
	"./video/people-balance-idle/21.webp": 83328,
	"./video/people-balance-idle/22.webp": 96539,
	"./video/people-balance-idle/23.webp": 45613,
	"./video/people-balance-idle/24.webp": 66709,
	"./video/people-balance-idle/25.webp": 89522,
	"./video/people-balance-idle/26.webp": 88938,
	"./video/people-balance-idle/27.webp": 83309,
	"./video/people-balance-idle/28.webp": 87258,
	"./video/people-balance-idle/29.webp": 97104,
	"./video/people-balance-idle/30.webp": 95523,
	"./video/people-balance-idle/31.webp": 18048,
	"./video/people-balance-idle/32.webp": 1529,
	"./video/people-balance-idle/33.webp": 16912,
	"./video/people-balance-idle/34.webp": 33496,
	"./video/people-balance-idle/35.webp": 40118,
	"./video/people-balance-idle/36.webp": 21317,
	"./video/people-balance-idle/37.webp": 38510,
	"./video/people-balance-idle/38.webp": 13709,
	"./video/people-balance-idle/39.webp": 55514,
	"./video/people-balance-idle/40.webp": 8645,
	"./video/people-balance-idle/41.webp": 33435,
	"./video/people-balance-idle/42.webp": 36394,
	"./video/people-balance-idle/43.webp": 86637,
	"./video/people-balance-idle/44.webp": 8637,
	"./video/people-balance-idle/45.webp": 76664,
	"./video/people-balance-idle/46.webp": 41540,
	"./video/people-balance-idle/47.webp": 78178,
	"./video/people-balance-idle/48.webp": 49417,
	"./video/people-balance-idle/49.webp": 50595,
	"./video/people-balance-idle/50.webp": 83610,
	"./video/people-balance-idle/51.webp": 16264,
	"./video/people-balance-idle/52.webp": 44268,
	"./video/people-balance-idle/53.webp": 1271,
	"./video/people-balance-initial.webm": 95158,
	"./video/people-balance-initial/00.webp": 37863,
	"./video/people-balance-initial/01.webp": 32438,
	"./video/people-balance-initial/02.webp": 38242,
	"./video/people-balance-initial/03.webp": 79416,
	"./video/people-balance-initial/04.webp": 69589,
	"./video/people-balance-initial/05.webp": 2575,
	"./video/people-balance-initial/06.webp": 37979,
	"./video/people-balance-initial/07.webp": 33953,
	"./video/people-balance-initial/08.webp": 8052,
	"./video/people-balance-initial/09.webp": 3232,
	"./video/people-balance-initial/10.webp": 99693,
	"./video/people-balance-initial/11.webp": 55567,
	"./video/people-balance-initial/12.webp": 68517,
	"./video/people-balance-initial/13.webp": 64075,
	"./video/people-balance-initial/14.webp": 44549,
	"./video/people-balance-initial/15.webp": 66983,
	"./video/people-balance-initial/16.webp": 5288,
	"./video/people-balance-initial/17.webp": 88863,
	"./video/people-balance-initial/18.webp": 81010,
	"./video/people-balance-initial/19.webp": 45700,
	"./video/people-balance-initial/20.webp": 21778,
	"./video/people-balance-initial/21.webp": 15896,
	"./video/people-balance-initial/22.webp": 7507,
	"./video/people-balance-initial/23.webp": 21205,
	"./video/people-balance-initial/24.webp": 26770,
	"./video/people-balance-initial/25.webp": 31900,
	"./video/people-balance-initial/26.webp": 55511,
	"./video/people-balance-initial/27.webp": 93132,
	"./video/people-balance-initial/28.webp": 85840,
	"./video/people-balance-initial/29.webp": 49098,
	"./video/people-balance-initial/30.webp": 13766,
	"./video/people-balance-initial/31.webp": 48923,
	"./video/people-balance-initial/32.webp": 67672,
	"./video/people-balance-initial/33.webp": 91162,
	"./video/people-balance-initial/34.webp": 58966,
	"./video/people-balance-initial/35.webp": 44851,
	"./video/people-balance-initial/36.webp": 65217,
	"./video/people-balance-initial/37.webp": 74913,
	"./video/people-balance-initial/38.webp": 83746,
	"./video/people-balance-initial/39.webp": 71302,
	"./video/people-balance-initial/40.webp": 11514,
	"./video/people-balance-initial/41.webp": 63670,
	"./video/people-balance-initial/42.webp": 5342,
	"./video/people-balance-initial/43.webp": 49595,
	"./video/people-balance-initial/44.webp": 67408,
	"./video/people-balance-initial/45.webp": 81906,
	"./video/people-balance-initial/46.webp": 1269,
	"./video/people-balance-initial/47.webp": 66806,
	"./video/people-balance-initial/48.webp": 33200,
	"./video/people-balance-initial/49.webp": 67732,
	"./video/people-balance-initial/50.webp": 4275,
	"./video/people-balance-initial/51.webp": 79106,
	"./video/people-balance-initial/52.webp": 30590,
	"./video/people-balance-initial/53.webp": 11548,
	"./video/people-balance-initial/54.webp": 58901,
	"./video/people-balance-initial/55.webp": 11621,
	"./video/people-balance-initial/56.webp": 56863,
	"./video/people-balance-initial/57.webp": 58866,
	"./video/people-balance-initial/58.webp": 6630,
	"./video/people-balance-initial/59.webp": 87644,
	"./video/people-idle.webm": 29976,
	"./video/people-idle/00.webp": 49035,
	"./video/people-idle/01.webp": 14065,
	"./video/people-idle/02.webp": 21953,
	"./video/people-idle/03.webp": 90745,
	"./video/people-idle/04.webp": 8123,
	"./video/people-idle/05.webp": 19927,
	"./video/people-idle/06.webp": 24276,
	"./video/people-idle/07.webp": 36326,
	"./video/people-idle/08.webp": 5361,
	"./video/people-idle/09.webp": 99468,
	"./video/people-idle/10.webp": 56603,
	"./video/people-idle/11.webp": 69110,
	"./video/people-idle/12.webp": 21712,
	"./video/people-idle/13.webp": 19745,
	"./video/people-idle/14.webp": 75511,
	"./video/people-idle/15.webp": 69932,
	"./video/people-idle/16.webp": 25082,
	"./video/people-idle/17.webp": 62888,
	"./video/people-idle/18.webp": 18796,
	"./video/people-idle/19.webp": 45164,
	"./video/people-idle/20.webp": 11631,
	"./video/people-idle/21.webp": 87976,
	"./video/people-idle/22.webp": 3727,
	"./video/people-idle/23.webp": 54939,
	"./video/people-idle/24.webp": 30285,
	"./video/people-idle/25.webp": 67352,
	"./video/people-idle/26.webp": 40665,
	"./video/people-idle/27.webp": 92075,
	"./video/people-idle/28.webp": 99350,
	"./video/people-idle/29.webp": 40443,
	"./video/people-idle/30.webp": 41833,
	"./video/people-idle/31.webp": 93701,
	"./video/people-idle/32.webp": 34205,
	"./video/people-idle/33.webp": 58511,
	"./video/people-idle/34.webp": 31958,
	"./video/people-idle/35.webp": 3658,
	"./video/people-idle/36.webp": 44436,
	"./video/people-idle/37.webp": 99044,
	"./video/people-idle/38.webp": 53262,
	"./video/people-idle/39.webp": 79601,
	"./video/people-idle/40.webp": 66263,
	"./video/people-idle/41.webp": 49105,
	"./video/people-idle/42.webp": 21680,
	"./video/people-idle/43.webp": 3472,
	"./video/people-idle/44.webp": 14267,
	"./video/people-idle/45.webp": 12455,
	"./video/people-idle/46.webp": 75331,
	"./video/people-idle/47.webp": 63994,
	"./video/people-idle/48.webp": 16538,
	"./video/people-idle/49.webp": 81684,
	"./video/people-idle/50.webp": 9293,
	"./video/people-idle/51.webp": 73620,
	"./video/people-idle/52.webp": 58663,
	"./video/people-idle/53.webp": 46637,
	"./video/people-idle/54.webp": 63653,
	"./video/people-idle/55.webp": 73631,
	"./video/people-idle/56.webp": 72092,
	"./video/people-idle/57.webp": 50400,
	"./video/people-idle/58.webp": 55517,
	"./video/people-idle/59.webp": 48927,
	"./video/people-idle/60.webp": 60948,
	"./video/people-idle/61.webp": 47936,
	"./video/people-idle/62.webp": 54193,
	"./video/people-idle/63.webp": 61089,
	"./video/people-idle/64.webp": 7551,
	"./video/people-idle/65.webp": 54258,
	"./video/people-idle/66.webp": 61518,
	"./video/people-idle/67.webp": 44326,
	"./video/people-idle/68.webp": 17765,
	"./video/people-idle/69.webp": 50648,
	"./video/people-idle/70.webp": 33236,
	"./video/people-idle/71.webp": 68854,
	"./video/people-idle/72.webp": 56637,
	"./video/people-idle/73.webp": 24727,
	"./video/people-idle/74.webp": 50566,
	"./video/people-idle/75.webp": 76344,
	"./video/people-idle/76.webp": 68363,
	"./video/people-idle/77.webp": 9771,
	"./video/people-idle/78.webp": 55611,
	"./video/people-idle/79.webp": 74350,
	"./video/people-idle/80.webp": 8028,
	"./video/people-idle/81.webp": 25435,
	"./video/people-idle/82.webp": 75455,
	"./video/people-idle/83.webp": 96976,
	"./video/people-idle/84.webp": 9895,
	"./video/people-idle/85.webp": 6662,
	"./video/people-initial.webm": 30662,
	"./video/people-initial/00.webp": 13741,
	"./video/people-initial/01.webp": 81590,
	"./video/people-initial/02.webp": 56934,
	"./video/people-initial/03.webp": 23147,
	"./video/people-initial/04.webp": 13622,
	"./video/people-initial/05.webp": 56008,
	"./video/people-initial/06.webp": 33658,
	"./video/people-initial/07.webp": 1816,
	"./video/people-initial/08.webp": 76616,
	"./video/people-initial/09.webp": 83416,
	"./video/people-initial/10.webp": 70131,
	"./video/people-initial/11.webp": 36681,
	"./video/people-initial/12.webp": 84726,
	"./video/people-initial/13.webp": 34084,
	"./video/people-initial/14.webp": 50676,
	"./video/people-initial/15.webp": 13182,
	"./video/people-initial/16.webp": 44593,
	"./video/people-initial/17.webp": 85603,
	"./video/people-initial/18.webp": 26485,
	"./video/people-initial/19.webp": 66923,
	"./video/people-initial/20.webp": 69326,
	"./video/people-initial/21.webp": 20505,
	"./video/people-initial/22.webp": 62691,
	"./video/people-initial/23.webp": 52327,
	"./video/people-initial/24.webp": 90736,
	"./video/people-initial/25.webp": 61092,
	"./video/people-initial/26.webp": 87477,
	"./video/people-initial/27.webp": 95284,
	"./video/people-initial/28.webp": 25323,
	"./video/people-initial/29.webp": 73350,
	"./video/people-initial/30.webp": 53904,
	"./video/people-initial/31.webp": 55203,
	"./video/people-initial/32.webp": 74287,
	"./video/people-initial/33.webp": 30079,
	"./video/people-initial/34.webp": 45143,
	"./video/planet-idle.webm": 3638,
	"./video/planet-idle/00.webp": 93699,
	"./video/planet-idle/01.webp": 84342,
	"./video/planet-idle/02.webp": 41361,
	"./video/planet-idle/03.webp": 47067,
	"./video/planet-idle/04.webp": 23949,
	"./video/planet-idle/05.webp": 38158,
	"./video/planet-idle/06.webp": 48826,
	"./video/planet-idle/07.webp": 98874,
	"./video/planet-idle/08.webp": 98372,
	"./video/planet-idle/09.webp": 55291,
	"./video/planet-idle/10.webp": 40477,
	"./video/planet-idle/11.webp": 22534,
	"./video/planet-idle/12.webp": 41455,
	"./video/planet-idle/13.webp": 79124,
	"./video/planet-idle/14.webp": 59292,
	"./video/planet-idle/15.webp": 43448,
	"./video/planet-idle/16.webp": 25636,
	"./video/planet-idle/17.webp": 77391,
	"./video/planet-idle/18.webp": 65677,
	"./video/planet-idle/19.webp": 51551,
	"./video/planet-idle/20.webp": 61075,
	"./video/planet-idle/21.webp": 25707,
	"./video/planet-idle/22.webp": 79934,
	"./video/planet-idle/23.webp": 19048,
	"./video/planet-idle/24.webp": 54285,
	"./video/planet-idle/25.webp": 2519,
	"./video/planet-idle/26.webp": 11696,
	"./video/planet-idle/27.webp": 99771,
	"./video/planet-idle/28.webp": 43169,
	"./video/planet-idle/29.webp": 78341,
	"./video/planet-idle/30.webp": 76777,
	"./video/planet-idle/31.webp": 30837,
	"./video/planet-idle/32.webp": 38047,
	"./video/planet-idle/33.webp": 12734,
	"./video/planet-idle/34.webp": 46522,
	"./video/planet-idle/35.webp": 88341,
	"./video/planet-idle/36.webp": 32319,
	"./video/planet-idle/37.webp": 61332,
	"./video/planet-idle/38.webp": 71033,
	"./video/planet-idle/39.webp": 48125,
	"./video/planet-idle/40.webp": 68871,
	"./video/planet-idle/41.webp": 84104,
	"./video/planet-idle/42.webp": 4704,
	"./video/planet-idle/43.webp": 77033,
	"./video/planet-idle/44.webp": 32509,
	"./video/planet-idle/45.webp": 13130,
	"./video/planet-idle/46.webp": 66153,
	"./video/planet-idle/47.webp": 91899,
	"./video/planet-idle/48.webp": 69963,
	"./video/planet-idle/49.webp": 69202,
	"./video/planet-idle/50.webp": 47925,
	"./video/planet-idle/51.webp": 55354,
	"./video/planet-idle/52.webp": 81418,
	"./video/planet-idle/53.webp": 47620,
	"./video/planet-idle/54.webp": 14814,
	"./video/planet-idle/55.webp": 73345,
	"./video/planet-idle/56.webp": 74473,
	"./video/planet-idle/57.webp": 59939,
	"./video/planet-idle/58.webp": 33437,
	"./video/planet-idle/59.webp": 94462,
	"./video/planet-idle/60.webp": 21620,
	"./video/planet-idle/61.webp": 57423,
	"./video/planet-idle/62.webp": 41258,
	"./video/planet-idle/63.webp": 41153,
	"./video/planet-idle/64.webp": 9408,
	"./video/planet-idle/65.webp": 77641,
	"./video/planet-idle/66.webp": 22704,
	"./video/planet-idle/67.webp": 48741,
	"./video/planet-idle/68.webp": 27340,
	"./video/planet-idle/69.webp": 86651,
	"./video/planet-idle/70.webp": 62717,
	"./video/planet-idle/71.webp": 30287,
	"./video/planet-idle/72.webp": 6142,
	"./video/planet-idle/73.webp": 29636,
	"./video/planet-idle/74.webp": 21233,
	"./video/planet-idle/75.webp": 47888,
	"./video/planet-idle/76.webp": 81448,
	"./video/planet-idle/77.webp": 36620,
	"./video/planet-idle/78.webp": 89746,
	"./video/planet-idle/79.webp": 28294,
	"./video/planet-idle/80.webp": 35964,
	"./video/planet-idle/81.webp": 555,
	"./video/planet-idle/82.webp": 25590,
	"./video/planet-idle/83.webp": 65758,
	"./video/planet-idle/84.webp": 61922,
	"./video/planet-idle/85.webp": 67154,
	"./video/planet-idle/86.webp": 77729,
	"./video/planet-idle/87.webp": 50009,
	"./video/planet-idle/88.webp": 15388,
	"./video/planet-idle/89.webp": 30184,
	"./video/planet-initial.webm": 64185,
	"./video/planet-initial/00.webp": 21773,
	"./video/planet-initial/01.webp": 36982,
	"./video/planet-initial/02.webp": 91734,
	"./video/planet-initial/03.webp": 66616,
	"./video/planet-initial/04.webp": 90872,
	"./video/planet-initial/05.webp": 87764,
	"./video/planet-initial/06.webp": 490,
	"./video/planet-initial/07.webp": 51751,
	"./video/planet-initial/08.webp": 60403,
	"./video/planet-initial/09.webp": 22924,
	"./video/planet-initial/10.webp": 45252,
	"./video/planet-initial/11.webp": 24385,
	"./video/planet-initial/12.webp": 22292,
	"./video/planet-initial/13.webp": 7070,
	"./video/planet-initial/14.webp": 73566,
	"./video/planet-initial/15.webp": 12879,
	"./video/planet-initial/16.webp": 69818,
	"./video/planet-initial/17.webp": 62105,
	"./video/planet-initial/18.webp": 84382,
	"./video/planet-initial/19.webp": 59400,
	"./video/planet-initial/20.webp": 96429,
	"./video/planet-initial/21.webp": 50588,
	"./video/planet-initial/22.webp": 39804,
	"./video/planet-initial/23.webp": 62026,
	"./video/planet-initial/24.webp": 3230,
	"./video/planet-initial/25.webp": 69290,
	"./video/planet-initial/26.webp": 41001,
	"./video/planet-initial/27.webp": 13102,
	"./video/planet-initial/28.webp": 46822,
	"./video/planet-initial/29.webp": 35944,
	"./video/planet-initial/30.webp": 50538,
	"./video/planet-initial/31.webp": 22060,
	"./video/planet-initial/32.webp": 91969,
	"./video/planet-initial/33.webp": 66430,
	"./video/planet-initial/34.webp": 96524,
	"./video/planet-initial/35.webp": 76360,
	"./video/planet-initial/36.webp": 82168,
	"./video/planet-initial/37.webp": 62305,
	"./video/planet-initial/38.webp": 55314,
	"./video/planet-initial/39.webp": 16314,
	"./video/planet-initial/40.webp": 24196,
	"./video/planet-initial/41.webp": 6397,
	"./video/planet-initial/42.webp": 39539,
	"./video/planet-initial/43.webp": 85712,
	"./video/planet-initial/44.webp": 95922,
	"./video/planet-initial/45.webp": 70962,
	"./video/planet-initial/46.webp": 32562,
	"./video/planet-initial/47.webp": 43270,
	"./video/planet-initial/48.webp": 80348,
	"./video/planet-initial/49.webp": 84395,
	"./video/planet-initial/50.webp": 10834,
	"./video/planet-initial/51.webp": 19160,
	"./video/planet-planter-idle.webm": 84144,
	"./video/planet-planter-idle/00.webp": 5826,
	"./video/planet-planter-idle/01.webp": 70930,
	"./video/planet-planter-idle/02.webp": 16208,
	"./video/planet-planter-idle/03.webp": 83022,
	"./video/planet-planter-idle/04.webp": 87985,
	"./video/planet-planter-idle/05.webp": 85586,
	"./video/planet-planter-idle/06.webp": 94687,
	"./video/planet-planter-idle/07.webp": 36474,
	"./video/planet-planter-idle/08.webp": 45346,
	"./video/planet-planter-idle/09.webp": 15978,
	"./video/planet-planter-idle/10.webp": 9136,
	"./video/planet-planter-idle/11.webp": 83766,
	"./video/planet-planter-idle/12.webp": 40111,
	"./video/planet-planter-idle/13.webp": 58692,
	"./video/planet-planter-idle/14.webp": 81090,
	"./video/planet-planter-idle/15.webp": 94920,
	"./video/planet-planter-idle/16.webp": 10230,
	"./video/planet-planter-idle/17.webp": 51489,
	"./video/planet-planter-idle/18.webp": 22618,
	"./video/planet-planter-idle/19.webp": 64124,
	"./video/planet-planter-idle/20.webp": 70068,
	"./video/planet-planter-idle/21.webp": 90297,
	"./video/planet-planter-idle/22.webp": 61489,
	"./video/planet-planter-idle/23.webp": 6297,
	"./video/planet-planter-idle/24.webp": 90714,
	"./video/planet-planter-idle/25.webp": 46149,
	"./video/planet-planter-idle/26.webp": 96589,
	"./video/planet-planter-idle/27.webp": 24391,
	"./video/planet-planter-idle/28.webp": 83521,
	"./video/planet-planter-idle/29.webp": 19441,
	"./video/planet-planter-idle/30.webp": 48200,
	"./video/planet-planter-idle/31.webp": 82447,
	"./video/planet-planter-idle/32.webp": 26357,
	"./video/planet-planter-idle/33.webp": 8549,
	"./video/planet-planter-idle/34.webp": 42357,
	"./video/planet-planter-idle/35.webp": 65289,
	"./video/planet-planter-idle/36.webp": 40379,
	"./video/planet-planter-idle/37.webp": 8942,
	"./video/planet-planter-idle/38.webp": 73955,
	"./video/planet-planter-idle/39.webp": 10261,
	"./video/planet-planter-idle/40.webp": 76292,
	"./video/planet-planter-idle/41.webp": 17556,
	"./video/planet-planter-idle/42.webp": 90877,
	"./video/planet-planter-idle/43.webp": 69008,
	"./video/planet-planter-idle/44.webp": 7315,
	"./video/planet-planter-idle/45.webp": 17181,
	"./video/planet-planter-idle/46.webp": 92087,
	"./video/planet-planter-idle/47.webp": 25820,
	"./video/planet-planter-idle/48.webp": 27642,
	"./video/planet-planter-idle/49.webp": 64426,
	"./video/planet-planter-idle/50.webp": 89841,
	"./video/planet-planter-idle/51.webp": 56566,
	"./video/planet-planter-idle/52.webp": 59158,
	"./video/planet-planter-idle/53.webp": 97430,
	"./video/planet-planter-idle/54.webp": 20832,
	"./video/planet-planter-idle/55.webp": 57707,
	"./video/planet-planter-idle/56.webp": 12524,
	"./video/planet-planter-idle/57.webp": 40999,
	"./video/planet-planter-idle/58.webp": 51569,
	"./video/planet-planter-idle/59.webp": 54014,
	"./video/planet-planter-idle/60.webp": 97924,
	"./video/planet-planter-idle/61.webp": 85116,
	"./video/planet-planter-idle/62.webp": 22652,
	"./video/planet-planter-idle/63.webp": 67754,
	"./video/planet-planter-idle/64.webp": 49468,
	"./video/planet-planter-idle/65.webp": 22632,
	"./video/planet-planter-idle/66.webp": 1190,
	"./video/planet-planter-idle/67.webp": 90547,
	"./video/planet-planter-idle/68.webp": 35870,
	"./video/planet-planter-idle/69.webp": 11130,
	"./video/planet-planter-idle/70.webp": 39249,
	"./video/planet-planter-idle/71.webp": 94419,
	"./video/planet-planter-idle/72.webp": 8973,
	"./video/planet-planter-idle/73.webp": 9433,
	"./video/planet-planter-idle/74.webp": 66279,
	"./video/planet-planter-idle/75.webp": 30911,
	"./video/planet-planter-idle/76.webp": 57918,
	"./video/planet-planter-idle/77.webp": 19695,
	"./video/planet-planter-idle/78.webp": 34398,
	"./video/planet-planter-idle/79.webp": 32328,
	"./video/planet-planter-idle/80.webp": 49064,
	"./video/planet-planter-idle/81.webp": 3520,
	"./video/planet-planter-idle/82.webp": 44045,
	"./video/planet-planter-idle/83.webp": 75917,
	"./video/planet-planter-idle/84.webp": 79780,
	"./video/planet-planter-idle/85.webp": 45368,
	"./video/planet-planter-idle/86.webp": 84463,
	"./video/planet-planter-idle/87.webp": 16809,
	"./video/planet-planter-idle/88.webp": 62907,
	"./video/planet-planter-idle/89.webp": 28526,
	"./video/planet-planter-idle/90.webp": 84981,
	"./video/planet-planter-initial.webm": 13043,
	"./video/planet-planter-initial/00.webp": 23487,
	"./video/planet-planter-initial/01.webp": 43606,
	"./video/planet-planter-initial/02.webp": 86714,
	"./video/planet-planter-initial/03.webp": 75156,
	"./video/planet-planter-initial/04.webp": 74971,
	"./video/planet-planter-initial/05.webp": 17472,
	"./video/planet-planter-initial/06.webp": 8294,
	"./video/planet-planter-initial/07.webp": 48449,
	"./video/planet-planter-initial/08.webp": 3898,
	"./video/planet-planter-initial/09.webp": 89337,
	"./video/planet-planter-initial/10.webp": 85836,
	"./video/planet-planter-initial/11.webp": 89155,
	"./video/planet-planter-initial/12.webp": 99663,
	"./video/planet-planter-initial/13.webp": 40887,
	"./video/planet-planter-initial/14.webp": 92966,
	"./video/planet-planter-initial/15.webp": 14340,
	"./video/planet-planter-initial/16.webp": 23202,
	"./video/planet-planter-initial/17.webp": 99356,
	"./video/planet-planter-initial/18.webp": 81703,
	"./video/planet-planter-initial/19.webp": 82677,
	"./video/planet-planter-initial/20.webp": 65304,
	"./video/planet-planter-initial/21.webp": 67176,
	"./video/planet-planter-initial/22.webp": 29082,
	"./video/planet-planter-initial/23.webp": 61719,
	"./video/planet-planter-initial/24.webp": 63516,
	"./video/planet-planter-initial/25.webp": 495,
	"./video/planet-planter-initial/26.webp": 52045,
	"./video/planet-planter-initial/27.webp": 4946,
	"./video/planet-planter-initial/28.webp": 34755,
	"./video/planet-planter-initial/29.webp": 45302,
	"./video/planet-planter-initial/30.webp": 54122,
	"./video/planet-planter-initial/31.webp": 32944,
	"./video/planet-planter-initial/32.webp": 53107,
	"./video/planet-planter-initial/33.webp": 70459,
	"./video/planet-planter-initial/34.webp": 40846,
	"./video/planet-planter-initial/35.webp": 54155,
	"./video/planet-planter-initial/36.webp": 30626,
	"./video/planet-planter-initial/37.webp": 79426,
	"./video/planet-planter-initial/38.webp": 93615,
	"./video/planet-planter-initial/39.webp": 76269,
	"./video/planet-planter-initial/40.webp": 71487,
	"./video/planet-planter-initial/41.webp": 44457,
	"./video/planet-planter-initial/42.webp": 97527,
	"./video/planet-planter-initial/43.webp": 71738,
	"./video/planet-planter-initial/44.webp": 11814,
	"./video/planet-planter-initial/45.webp": 6725,
	"./video/planet-planter-initial/46.webp": 22234,
	"./video/planet-planter-initial/47.webp": 51293,
	"./video/planet-planter-initial/48.webp": 71688,
	"./video/planet-planter-initial/49.webp": 43853,
	"./video/planet-planter-initial/50.webp": 59525,
	"./video/planet-planter-initial/51.webp": 38357,
	"./video/planet-planter-initial/52.webp": 84694,
	"./video/planet-planter-initial/53.webp": 14502,
	"./video/progress-3squares-idle.webm": 88437,
	"./video/progress-3squares-idle/00.webp": 66615,
	"./video/progress-3squares-idle/01.webp": 51404,
	"./video/progress-3squares-idle/02.webp": 44770,
	"./video/progress-3squares-idle/03.webp": 9213,
	"./video/progress-3squares-idle/04.webp": 63639,
	"./video/progress-3squares-idle/05.webp": 12844,
	"./video/progress-3squares-idle/06.webp": 64436,
	"./video/progress-3squares-idle/07.webp": 29657,
	"./video/progress-3squares-idle/08.webp": 67869,
	"./video/progress-3squares-idle/09.webp": 20616,
	"./video/progress-3squares-idle/10.webp": 5908,
	"./video/progress-3squares-idle/100.webp": 93688,
	"./video/progress-3squares-idle/101.webp": 41291,
	"./video/progress-3squares-idle/11.webp": 44319,
	"./video/progress-3squares-idle/12.webp": 14826,
	"./video/progress-3squares-idle/13.webp": 94284,
	"./video/progress-3squares-idle/14.webp": 80670,
	"./video/progress-3squares-idle/15.webp": 55902,
	"./video/progress-3squares-idle/16.webp": 19694,
	"./video/progress-3squares-idle/17.webp": 67726,
	"./video/progress-3squares-idle/18.webp": 6820,
	"./video/progress-3squares-idle/19.webp": 60514,
	"./video/progress-3squares-idle/20.webp": 91428,
	"./video/progress-3squares-idle/21.webp": 44906,
	"./video/progress-3squares-idle/22.webp": 78565,
	"./video/progress-3squares-idle/23.webp": 24650,
	"./video/progress-3squares-idle/24.webp": 96636,
	"./video/progress-3squares-idle/25.webp": 36543,
	"./video/progress-3squares-idle/26.webp": 81531,
	"./video/progress-3squares-idle/27.webp": 37609,
	"./video/progress-3squares-idle/28.webp": 16286,
	"./video/progress-3squares-idle/29.webp": 56396,
	"./video/progress-3squares-idle/30.webp": 88958,
	"./video/progress-3squares-idle/31.webp": 83239,
	"./video/progress-3squares-idle/32.webp": 9818,
	"./video/progress-3squares-idle/33.webp": 49088,
	"./video/progress-3squares-idle/34.webp": 69802,
	"./video/progress-3squares-idle/35.webp": 21833,
	"./video/progress-3squares-idle/36.webp": 9250,
	"./video/progress-3squares-idle/37.webp": 55162,
	"./video/progress-3squares-idle/38.webp": 55386,
	"./video/progress-3squares-idle/39.webp": 65597,
	"./video/progress-3squares-idle/40.webp": 57395,
	"./video/progress-3squares-idle/41.webp": 88786,
	"./video/progress-3squares-idle/42.webp": 34681,
	"./video/progress-3squares-idle/43.webp": 42219,
	"./video/progress-3squares-idle/44.webp": 55391,
	"./video/progress-3squares-idle/45.webp": 44093,
	"./video/progress-3squares-idle/46.webp": 97119,
	"./video/progress-3squares-idle/47.webp": 19314,
	"./video/progress-3squares-idle/48.webp": 39775,
	"./video/progress-3squares-idle/49.webp": 31483,
	"./video/progress-3squares-idle/50.webp": 2156,
	"./video/progress-3squares-idle/51.webp": 61408,
	"./video/progress-3squares-idle/52.webp": 77136,
	"./video/progress-3squares-idle/53.webp": 4226,
	"./video/progress-3squares-idle/54.webp": 90864,
	"./video/progress-3squares-idle/55.webp": 62410,
	"./video/progress-3squares-idle/56.webp": 93775,
	"./video/progress-3squares-idle/57.webp": 79342,
	"./video/progress-3squares-idle/58.webp": 45465,
	"./video/progress-3squares-idle/59.webp": 1645,
	"./video/progress-3squares-idle/60.webp": 57797,
	"./video/progress-3squares-idle/61.webp": 43563,
	"./video/progress-3squares-idle/62.webp": 16904,
	"./video/progress-3squares-idle/63.webp": 74198,
	"./video/progress-3squares-idle/64.webp": 67991,
	"./video/progress-3squares-idle/65.webp": 52939,
	"./video/progress-3squares-idle/66.webp": 18461,
	"./video/progress-3squares-idle/67.webp": 29801,
	"./video/progress-3squares-idle/68.webp": 62653,
	"./video/progress-3squares-idle/69.webp": 34361,
	"./video/progress-3squares-idle/70.webp": 71311,
	"./video/progress-3squares-idle/71.webp": 45150,
	"./video/progress-3squares-idle/72.webp": 18185,
	"./video/progress-3squares-idle/73.webp": 87144,
	"./video/progress-3squares-idle/74.webp": 68222,
	"./video/progress-3squares-idle/75.webp": 65493,
	"./video/progress-3squares-idle/76.webp": 61262,
	"./video/progress-3squares-idle/77.webp": 38742,
	"./video/progress-3squares-idle/78.webp": 64895,
	"./video/progress-3squares-idle/79.webp": 80301,
	"./video/progress-3squares-idle/80.webp": 27055,
	"./video/progress-3squares-idle/81.webp": 11254,
	"./video/progress-3squares-idle/82.webp": 55122,
	"./video/progress-3squares-idle/83.webp": 14431,
	"./video/progress-3squares-idle/84.webp": 47835,
	"./video/progress-3squares-idle/85.webp": 18575,
	"./video/progress-3squares-idle/86.webp": 31223,
	"./video/progress-3squares-idle/87.webp": 13161,
	"./video/progress-3squares-idle/88.webp": 19707,
	"./video/progress-3squares-idle/89.webp": 56715,
	"./video/progress-3squares-idle/90.webp": 97008,
	"./video/progress-3squares-idle/91.webp": 27792,
	"./video/progress-3squares-idle/92.webp": 73072,
	"./video/progress-3squares-idle/93.webp": 1159,
	"./video/progress-3squares-idle/94.webp": 86630,
	"./video/progress-3squares-idle/95.webp": 274,
	"./video/progress-3squares-idle/96.webp": 68333,
	"./video/progress-3squares-idle/97.webp": 44424,
	"./video/progress-3squares-idle/98.webp": 56691,
	"./video/progress-3squares-idle/99.webp": 81846,
	"./video/progress-3squares-initial.webm": 20474,
	"./video/progress-3squares-initial/00.webp": 87445,
	"./video/progress-3squares-initial/01.webp": 88571,
	"./video/progress-3squares-initial/02.webp": 18423,
	"./video/progress-3squares-initial/03.webp": 14112,
	"./video/progress-3squares-initial/04.webp": 90834,
	"./video/progress-3squares-initial/05.webp": 33750,
	"./video/progress-3squares-initial/06.webp": 82088,
	"./video/progress-3squares-initial/07.webp": 6990,
	"./video/progress-3squares-initial/08.webp": 36215,
	"./video/progress-3squares-initial/09.webp": 66965,
	"./video/progress-3squares-initial/10.webp": 77241,
	"./video/progress-3squares-initial/11.webp": 40725,
	"./video/progress-3squares-initial/12.webp": 22062,
	"./video/progress-3squares-initial/13.webp": 64038,
	"./video/progress-3squares-initial/14.webp": 3633,
	"./video/progress-3squares-initial/15.webp": 57696,
	"./video/progress-3squares-initial/16.webp": 40410,
	"./video/progress-3squares-initial/17.webp": 15877,
	"./video/progress-3squares-initial/18.webp": 22317,
	"./video/progress-3squares-initial/19.webp": 22783,
	"./video/progress-3squares-initial/20.webp": 53583,
	"./video/progress-3squares-initial/21.webp": 94377,
	"./video/progress-3squares-initial/22.webp": 96622,
	"./video/progress-3squares-initial/23.webp": 21694,
	"./video/progress-3squares-initial/24.webp": 73883,
	"./video/progress-3squares-initial/25.webp": 41373,
	"./video/progress-3squares-initial/26.webp": 92967,
	"./video/progress-3squares-initial/27.webp": 69220,
	"./video/progress-3squares-initial/28.webp": 55257,
	"./video/progress-3squares-initial/29.webp": 70569,
	"./video/progress-3squares-initial/30.webp": 19968,
	"./video/progress-3squares-initial/31.webp": 71946,
	"./video/progress-3squares-initial/32.webp": 46817,
	"./video/progress-3squares-initial/33.webp": 63478,
	"./video/progress-3squares-initial/34.webp": 86563,
	"./video/progress-3squares-initial/35.webp": 44364,
	"./video/progress-3squares-initial/36.webp": 47152,
	"./video/progress-3squares-initial/37.webp": 96269,
	"./video/progress-3squares-initial/38.webp": 2449,
	"./video/progress-3squares-initial/39.webp": 51076,
	"./video/progress-3squares-initial/40.webp": 24399,
	"./video/progress-3squares-initial/41.webp": 16102,
	"./video/progress-idle.webm": 20585,
	"./video/progress-idle/00.webp": 93953,
	"./video/progress-idle/01.webp": 84290,
	"./video/progress-idle/02.webp": 50065,
	"./video/progress-idle/03.webp": 83294,
	"./video/progress-idle/04.webp": 45138,
	"./video/progress-idle/05.webp": 45854,
	"./video/progress-idle/06.webp": 29449,
	"./video/progress-idle/07.webp": 43136,
	"./video/progress-idle/08.webp": 31091,
	"./video/progress-idle/09.webp": 62801,
	"./video/progress-idle/10.webp": 92951,
	"./video/progress-idle/11.webp": 77444,
	"./video/progress-idle/12.webp": 40766,
	"./video/progress-idle/13.webp": 51874,
	"./video/progress-idle/14.webp": 35737,
	"./video/progress-idle/15.webp": 97712,
	"./video/progress-idle/16.webp": 86712,
	"./video/progress-idle/17.webp": 32950,
	"./video/progress-idle/18.webp": 62503,
	"./video/progress-idle/19.webp": 83015,
	"./video/progress-idle/20.webp": 8024,
	"./video/progress-idle/21.webp": 32037,
	"./video/progress-idle/22.webp": 29963,
	"./video/progress-idle/23.webp": 75663,
	"./video/progress-idle/24.webp": 43624,
	"./video/progress-idle/25.webp": 74615,
	"./video/progress-idle/26.webp": 10730,
	"./video/progress-idle/27.webp": 34147,
	"./video/progress-idle/28.webp": 44450,
	"./video/progress-idle/29.webp": 98875,
	"./video/progress-idle/30.webp": 81422,
	"./video/progress-idle/31.webp": 94983,
	"./video/progress-idle/32.webp": 52295,
	"./video/progress-idle/33.webp": 23675,
	"./video/progress-idle/34.webp": 21892,
	"./video/progress-idle/35.webp": 17887,
	"./video/progress-idle/36.webp": 93558,
	"./video/progress-idle/37.webp": 28360,
	"./video/progress-idle/38.webp": 92446,
	"./video/progress-idle/39.webp": 1120,
	"./video/progress-idle/40.webp": 43571,
	"./video/progress-idle/41.webp": 52845,
	"./video/progress-idle/42.webp": 95707,
	"./video/progress-idle/43.webp": 7426,
	"./video/progress-idle/44.webp": 58263,
	"./video/progress-idle/45.webp": 79808,
	"./video/progress-idle/46.webp": 59494,
	"./video/progress-idle/47.webp": 98357,
	"./video/progress-idle/48.webp": 11300,
	"./video/progress-idle/49.webp": 28189,
	"./video/progress-idle/50.webp": 70069,
	"./video/progress-idle/51.webp": 14866,
	"./video/progress-idle/52.webp": 82497,
	"./video/progress-idle/53.webp": 1809,
	"./video/progress-idle/54.webp": 93612,
	"./video/progress-idle/55.webp": 16639,
	"./video/progress-idle/56.webp": 21510,
	"./video/progress-idle/57.webp": 55766,
	"./video/progress-idle/58.webp": 32733,
	"./video/progress-idle/59.webp": 32658,
	"./video/progress-idle/60.webp": 30166,
	"./video/progress-idle/61.webp": 9978,
	"./video/progress-idle/62.webp": 41541,
	"./video/progress-idle/63.webp": 61499,
	"./video/progress-idle/64.webp": 42922,
	"./video/progress-idle/65.webp": 39318,
	"./video/progress-idle/66.webp": 71656,
	"./video/progress-idle/67.webp": 14286,
	"./video/progress-idle/68.webp": 74301,
	"./video/progress-idle/69.webp": 30606,
	"./video/progress-idle/70.webp": 51280,
	"./video/progress-idle/71.webp": 35807,
	"./video/progress-idle/72.webp": 8703,
	"./video/progress-initial.webm": 72770,
	"./video/progress-initial/00.webp": 80476,
	"./video/progress-initial/01.webp": 92454,
	"./video/progress-initial/02.webp": 85867,
	"./video/progress-initial/03.webp": 75322,
	"./video/progress-initial/04.webp": 35462,
	"./video/progress-initial/05.webp": 18996,
	"./video/progress-initial/06.webp": 28624,
	"./video/progress-initial/07.webp": 79966,
	"./video/progress-initial/08.webp": 18543,
	"./video/progress-initial/09.webp": 4414,
	"./video/progress-initial/10.webp": 37648,
	"./video/progress-initial/11.webp": 8731,
	"./video/progress-initial/12.webp": 10853,
	"./video/progress-initial/13.webp": 78744,
	"./video/progress-initial/14.webp": 86067,
	"./video/progress-initial/15.webp": 62126,
	"./video/progress-initial/16.webp": 71328,
	"./video/progress-initial/17.webp": 3279,
	"./video/progress-initial/18.webp": 16505,
	"./video/progress-initial/19.webp": 65393,
	"./video/progress-initial/20.webp": 19542,
	"./video/progress-initial/21.webp": 85909,
	"./video/progress-initial/22.webp": 77188,
	"./video/progress-initial/23.webp": 37033,
	"./video/progress-initial/24.webp": 5733,
	"./video/progress-initial/25.webp": 89407,
	"./video/progress-initial/26.webp": 33549,
	"./video/progress-initial/27.webp": 6956,
	"./video/progress-initial/28.webp": 85271,
	"./video/progress-initial/29.webp": 2189,
	"./video/progress-initial/30.webp": 90796,
	"./video/progress-initial/31.webp": 94498,
	"./video/progress-initial/32.webp": 71935,
	"./video/progress-initial/33.webp": 80512,
	"./video/progress-initial/34.webp": 95459,
	"./video/progress-initial/35.webp": 27631,
	"./video/progress-initial/36.webp": 9636,
	"./video/progress-initial/37.webp": 30478,
	"./video/progress-initial/38.webp": 95760,
	"./video/progress-initial/39.webp": 86912,
	"./video/progress-initial/40.webp": 84228,
	"./video/progress-initial/41.webp": 41857,
	"./video/progress-initial/42.webp": 43746,
	"./video/progress-initial/43.webp": 66170,
	"./video/progress-initial/44.webp": 38905,
	"./video/progress-initial/45.webp": 59890,
	"./video/progress-initial/46.webp": 625,
	"./video/progress-initial/47.webp": 8445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63688;